import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { tick } from "svelte";
import { LocalStorageConfigStorage } from "../adapters/storage/local-storage-config-storage.js";
import { ConfigParser } from "../adapters/config/config-parser.js";
import ConfigWizard from "./ConfigWizard.svelte";
import ConfigPages from "./ConfigPages.svelte";

import {
	moveConfigPage,
	readConfigPages,
	readDisplaySettings,
	removeConfigPage,
	removeConfigStop,
	updateConfigPage,
	updateConfigStop,
	addConfigPage,
	addConfigStop,
	updateDisplaySettings
} from "../utils/config-pages.js";

import { applyWizardConfig, getWizardConfigContext } from "../utils/config-modifier.js";
import { cleanUpConfigToml, describeCleanup } from "../utils/config-cleanup.js";
import { highlightToml } from "../utils/toml-highlight.js";

import {
	addOnTheRunSection,
	draftOfOnTheRun,
	hasOnTheRun,
	ON_THE_RUN_FIELDS,
	readOnTheRunSettings,
	settingsOfOnTheRunDraft,
	updateOnTheRunSettings
} from "../utils/on-the-run-section.js";

import { fetchToml, rawConfigUrl } from "../utils/config-url.js";

var root = $.from_html(`<p class="delete-routes-empty svelte-ha7zfr">Nothing to delete yet: this config has no pages.</p>`);
var root_1 = $.from_html(`<p class="delete-routes-hint svelte-ha7zfr" role="status">A configuration needs a page: leave at least one unticked.</p>`);
var root_2 = $.from_html(`<label class="delete-routes-item delete-item svelte-ha7zfr" role="listitem"><input type="checkbox" class="delete-checkbox svelte-ha7zfr"/> <span class="delete-routes-label delete-item-label svelte-ha7zfr"> <span class="delete-routes-path svelte-ha7zfr"> </span></span></label>`);
var root_3 = $.from_html(`<div class="delete-routes-list delete-list svelte-ha7zfr" role="list"></div>`);
var root_4 = $.from_html(`<li> <span class="delete-routes-path svelte-ha7zfr"> </span></li>`);
var root_5 = $.from_html(`<div class="delete-confirm svelte-ha7zfr"><h3 class="svelte-ha7zfr">Confirm deletion</h3> <ul class="svelte-ha7zfr"></ul></div>`);
var root_6 = $.from_html(`<!> <!>`, 1);
var root_7 = $.from_html(`<button class="button button-secondary">Back</button> <button class="button button-secondary">Cancel</button> <button class="button button-primary">Confirm Delete</button>`, 1);
var root_8 = $.from_html(`<button class="button button-secondary">Cancel</button> <button class="button button-primary">Review Delete</button>`, 1);
var root_9 = $.from_html(`<div class="modal-footer svelte-ha7zfr"><!></div>`);
var root_10 = $.from_html(`<div class="modal-content delete-routes-content svelte-ha7zfr"><div class="modal-header svelte-ha7zfr"><h2 class="svelte-ha7zfr">Delete Routes</h2> <button class="close-button svelte-ha7zfr" aria-label="Close">×</button></div> <div class="modal-body svelte-ha7zfr"><p class="delete-routes-hint svelte-ha7zfr">Select the routes to remove from your configuration.</p> <!></div> <!></div>`);
var root_11 = $.from_html(`<div class="error-message svelte-ha7zfr" role="alert"> </div>`);
var root_12 = $.from_html(`<div class="delete-disabled svelte-ha7zfr">Delete is not available for this route.</div>`);
var root_13 = $.from_html(`<div class="delete-disabled svelte-ha7zfr">No deletable headers found.</div>`);
var root_14 = $.from_html(`<label class="delete-item svelte-ha7zfr" role="listitem"><input type="checkbox" class="delete-checkbox svelte-ha7zfr"/> <span class="delete-item-label svelte-ha7zfr"> </span></label>`);
var root_15 = $.from_html(`<div class="delete-list svelte-ha7zfr" role="list"></div>`);
var root_16 = $.from_html(`<li> </li>`);

var root_17 = $.from_html(`<div class="modal-content svelte-ha7zfr"><div class="modal-header svelte-ha7zfr"><h2 class="svelte-ha7zfr">Delete from Current Route</h2> <button class="close-button svelte-ha7zfr" aria-label="Close">×</button></div> <div class="modal-body svelte-ha7zfr"><p class="delete-route-label svelte-ha7zfr">Current route: <strong> </strong></p> <p class="delete-hint svelte-ha7zfr">Select the headers to delete (current route only). Next to me is
          excluded.</p> <!> <!></div> <div class="modal-footer svelte-ha7zfr"><!></div></div>`);

var root_18 = $.from_html(`<div class="cleanup-review svelte-ha7zfr" role="status"><p class="cleanup-review-title svelte-ha7zfr">Review the clean-up before applying it</p> <p class="svelte-ha7zfr"> </p> <div class="cleanup-review-actions svelte-ha7zfr"><button class="button button-secondary">Cancel clean-up</button> <button class="button button-primary">Apply clean-up</button></div></div>`);
var root_19 = $.from_html(`<div class="config-notice svelte-ha7zfr" role="status"> </div>`);
var root_20 = $.from_html(`<button class="button button-secondary svelte-ha7zfr" title="Change the radius, the number of departures and the API">Edit</button>`);
var root_21 = $.from_html(`<button class="button button-primary svelte-ha7zfr" title="Add the nearby-departures page back to the config">Restore</button>`);
var root_22 = $.from_html(`<input type="checkbox" class="svelte-ha7zfr"/>`);
var root_23 = $.from_html(`<input class="svelte-ha7zfr"/>`);
var root_24 = $.from_html(`<small class="on-the-run-hint svelte-ha7zfr"> </small>`);
var root_25 = $.from_html(`<label class="on-the-run-field svelte-ha7zfr"><span class="on-the-run-label svelte-ha7zfr"> </span> <!> <!></label>`);
var root_26 = $.from_html(`<div class="page-row-form svelte-ha7zfr"><div class="on-the-run-fields svelte-ha7zfr"></div> <div class="page-row-actions svelte-ha7zfr"><button class="button button-secondary">Cancel</button> <button class="button button-primary">Apply</button></div></div>`);
var root_27 = $.from_html(`<div class="modal-overlay svelte-ha7zfr" role="dialog" aria-modal="true" aria-label="Configurator"><div class="modal-content configurator-panel svelte-ha7zfr"><div class="modal-header svelte-ha7zfr"><h2 class="svelte-ha7zfr">Configurator</h2> <button class="close-button svelte-ha7zfr" aria-label="Close the configurator">×</button></div> <div class="modal-body svelte-ha7zfr"><div class="page-row svelte-ha7zfr"><div class="page-row-text svelte-ha7zfr"><strong class="svelte-ha7zfr">Next to me</strong> <span class="page-row-hint svelte-ha7zfr"> </span></div> <!></div> <!> <!></div> <div class="modal-footer svelte-ha7zfr"><div class="modal-footer-actions svelte-ha7zfr"><button class="button button-primary">Done</button></div></div></div></div>`);
var root_28 = $.from_html(`<span class="success-indicator svelte-ha7zfr">✓</span>`);
var root_29 = $.from_html(`<span class="error-indicator svelte-ha7zfr">✗</span>`);
var root_30 = $.from_html(`<div class="fullscreen-editor-overlay svelte-ha7zfr" role="dialog" aria-modal="true" tabindex="-1"><div class="fullscreen-editor-content svelte-ha7zfr"><button class="button button-primary fullscreen-close svelte-ha7zfr">Done</button> <textarea class="fullscreen-textarea svelte-ha7zfr" spellcheck="false"></textarea></div></div>`);
var root_31 = $.from_html(`<button type="button" class="tweak-filter-clear svelte-ha7zfr" aria-label="Clear filter" title="Clear filter">×</button>`);

var root_32 = $.from_html(`<p class="tweak-empty svelte-ha7zfr">No sections found. Add at least one TOML section (a line
                        starting with [).</p>`);

var root_33 = $.from_html(`<span class="tweak-section-context svelte-ha7zfr"> </span>`);
var root_34 = $.from_html(`<span class="tweak-key-context svelte-ha7zfr"> </span>`);
var root_35 = $.from_html(`<li class="tweak-entry svelte-ha7zfr"><label class="tweak-key svelte-ha7zfr"> <!></label> <input type="text" class="tweak-value svelte-ha7zfr"/></li>`);
var root_36 = $.from_html(`<section class="tweak-section svelte-ha7zfr"><h3 class="tweak-section-title svelte-ha7zfr"> <!></h3> <ul class="tweak-entries svelte-ha7zfr"></ul></section>`);
var root_37 = $.from_html(`<div class="tweak-overlay svelte-ha7zfr" role="dialog" aria-modal="true" aria-label="Tweak display values" tabindex="-1"><div class="tweak-overlay-content svelte-ha7zfr"><div class="tweak-close-bar svelte-ha7zfr"><div class="tweak-filter-wrap svelte-ha7zfr"><input type="text" class="tweak-filter-input svelte-ha7zfr" placeholder="Filter (space-separated, all must match)" aria-label="Filter entries"/> <!></div> <button class="button button-primary tweak-close svelte-ha7zfr">Ok</button></div> <div class="tweak-list svelte-ha7zfr"><!></div></div></div>`);
var root_38 = $.from_html(`<div class="textarea-container svelte-ha7zfr"><div class="textarea-toolbar svelte-ha7zfr"><button class="icon-button svelte-ha7zfr" aria-label="Copy configuration"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115.77 122.88" class="icon svelte-ha7zfr"><path d="M89.62,13.96v7.73h12.19h0.01v0.02c3.85,0.01,7.34,1.57,9.86,4.1c2.5,2.51,4.06,5.98,4.07,9.82h0.02v0.02 v73.27v0.01h-0.02c-0.01,3.84-1.57,7.33-4.1,9.86c-2.51,2.5-5.98,4.06-9.82,4.07v0.02h-0.02h-61.7H40.1v-0.02 c-3.84-0.01-7.34-1.57-9.86-4.1c-2.5-2.51-4.06-5.98-4.07-9.82h-0.02v-0.02V92.51H13.96h-0.01v-0.02c-3.84-0.01-7.34-1.57-9.86-4.1 c-2.5-2.51-4.06-5.98-4.07-9.82H0v-0.02V13.96v-0.01h0.02c0.01-3.85,1.58-7.34,4.1-9.86c2.51-2.5,5.98-4.06,9.82-4.07V0h0.02h61.7 h0.01v0.02c3.85,0.01,7.34,1.57,9.86,4.1c2.5,2.51,4.06,5.98,4.07,9.82h0.02V13.96L89.62,13.96z M79.04,21.69v-7.73v-0.02h0.02 c0-0.91-0.39-1.75-1.01-2.37c-0.61-0.61-1.46-1-2.37-1v0.02h-0.01h-61.7h-0.02v-0.02c-0.91,0-1.75,0.39-2.37,1.01 c-0.61,0.61-1,1.46-1,2.37h0.02v0.01v64.59v0.02h-0.02c0,0.91,0.39,1.75,1.01,2.37c0.61,0.61,1.46,1,2.37,1v-0.02h0.01h12.19V35.65 v-0.01h0.02c0.01-3.85,1.58-7.34,4.1-9.86c2.51-2.5,5.98-4.06,9.82-4.07v-0.02h0.02H79.04L79.04,21.69z M105.18,108.92V35.65v-0.02 h0.02c0-0.91-0.39-1.75-1.01-2.37c-0.61-0.61-1.46-1-2.37-1v0.02h-0.01h-61.7h-0.02v-0.02c-0.91,0-1.75,0.39-2.37,1.01 c-0.61,0.61-1,1.46-1,2.37h0.02v0.01v73.27v0.02h-0.02c0,0.91,0.39,1.75,1.01,2.37c0.61,0.61,1.46,1,2.37,1v-0.02h0.01h61.7h0.02 v0.02c0.91,0,1.75-0.39,2.37-1.01c0.61-0.61,1-1.46,1-2.37h-0.02V108.92L105.18,108.92z"></path></svg> <!></button> <button class="icon-button svelte-ha7zfr" aria-label="Paste configuration"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 399 512.02" class="icon svelte-ha7zfr"><path d="M96.59 35.73h34.9C133.94 15.58 150.2 0 169.92 0c19.6 0 35.77 15.37 38.39 35.31l35.47.42c2.37 0 4.26 1.89 4.26 4.26V87c0 2.36-1.89 4.26-4.26 4.26H96.63c-2.31 0-4.26-1.9-4.26-4.26V39.99c-.04-2.37 1.86-4.26 4.22-4.26zm108.07 301.63c-5.44 0-9.86-4.42-9.86-9.87 0-5.44 4.42-9.86 9.86-9.86h124.93c5.45 0 9.86 4.42 9.86 9.86 0 5.45-4.41 9.87-9.86 9.87H204.66zm103.16-170.67h.88c3.12 0 5.9 1.44 7.7 3.7l80.02 87.86a9.845 9.845 0 0 1 2.56 6.62l.02 2.66v223.28c0 5.81-2.41 11.13-6.25 14.97s-9.15 6.24-14.96 6.24H156.47c-5.77 0-11.08-2.39-14.94-6.24l-.04-.04c-3.84-3.87-6.23-9.14-6.23-14.93V187.7c0-5.83 2.38-11.14 6.22-14.98s9.15-6.23 14.99-6.23h149.37c.68 0 1.34.07 1.98.2zm71.46 110.8c-43.74-1.7-65.42-3.27-77.68-16.13-12.27-12.88-11.51-32.56-10.03-70.26l.19-4.88H156.47c-.41 0-.78.17-1.05.44-.27.26-.44.64-.44 1.04v303.11c0 .41.16.78.41 1.03l.04.04c.26.26.63.42 1.04.42h221.32c.37 0 .74-.18 1.02-.46s.47-.65.47-1.03V277.49zm-68.25-80.91c-1.13 29.16-1.41 44.68 4.82 51.22 6.15 6.45 21.33 8.17 50.65 9.5l-55.47-60.72zM204.66 447.87c-5.44 0-9.86-4.41-9.86-9.86 0-5.44 4.42-9.86 9.86-9.86h124.93c5.45 0 9.86 4.42 9.86 9.86 0 5.45-4.41 9.86-9.86 9.86H204.66zm0-55.26c-5.44 0-9.86-4.41-9.86-9.86 0-5.44 4.42-9.86 9.86-9.86h124.93c5.45 0 9.86 4.42 9.86 9.86 0 5.45-4.41 9.86-9.86 9.86H204.66zm-104.29 7.49c6.93 0 12.55 5.62 12.55 12.55 0 6.92-5.62 12.55-12.55 12.55H39.33c-10.72 0-20.58-4.45-27.75-11.61C4.45 406.51 0 396.69 0 385.86V91.56C0 80.73 4.42 70.9 11.54 63.78l.84-.77c7.05-6.66 16.55-10.77 26.95-10.77h32.46v25.11H39.33c-3.68 0-7.05 1.4-9.57 3.69l-.47.49c-2.58 2.58-4.19 6.14-4.19 10.03v294.3c0 3.87 1.63 7.42 4.21 10.01v.05c2.58 2.58 6.14 4.18 10.02 4.18h61.04zM268.61 52.24h32.44c10.79 0 20.6 4.45 27.72 11.56 7.17 7.16 11.62 17.02 11.62 27.76v29.91c0 6.93-5.62 12.55-12.55 12.55-6.93 0-12.55-5.62-12.55-12.55V91.56c0-3.88-1.6-7.44-4.17-10.01-2.58-2.58-6.15-4.2-10.07-4.2h-32.44V52.24zm-99.13-33.96c11.15 0 20.18 9.03 20.18 20.18s-9.03 20.19-20.18 20.19-20.19-9.04-20.19-20.19c0-11.15 9.04-20.18 20.19-20.18z"></path></svg> <!></button> <button class="icon-button svelte-ha7zfr" title="Tweak numeric and display values" aria-label="Tweak display values"><img src="assets/settings-line-icon.svg" alt="" class="icon svelte-ha7zfr"/></button> <button class="icon-button svelte-ha7zfr" title="Expand editor for mobile editing" aria-label="Expand editor"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon svelte-ha7zfr"><path d="M4 4h7V2H2v9h2V4zm16 0v7h2V2h-9v2h7zm0 16h-7v2h9v-9h-2v7zM4 20v-7H2v9h9v-2H4z"></path></svg></button></div>  <div class="editor-stack svelte-ha7zfr"><pre class="editor-highlight svelte-ha7zfr" aria-hidden="true"><code></code></pre> <textarea placeholder="Paste TOML config here..."></textarea></div> <!> <!></div>`);
var root_39 = $.from_html(`<span class="discard-question svelte-ha7zfr">Discard the changes?</span> <button class="button button-secondary">Keep editing</button> <button class="button button-danger">Discard changes</button>`, 1);
var root_40 = $.from_html(`<button class="button button-example svelte-ha7zfr" title="Load example configuration"> </button> <button class="button button-secondary">Cancel</button> <button class="button button-primary"> </button>`, 1);
var root_41 = $.from_html(`<div class="modal-content svelte-ha7zfr"><div class="modal-header svelte-ha7zfr"><h2 class="svelte-ha7zfr">Configuration</h2> <button class="close-button svelte-ha7zfr" aria-label="Close">×</button></div> <div class="config-method-selector svelte-ha7zfr" role="tablist"><button role="tab">TOML Config</button> <button class="method-button svelte-ha7zfr">Wizard (experimental)</button> <button class="method-button svelte-ha7zfr" title="Delete headers from the current route">Delete (current route)</button> <button class="method-button svelte-ha7zfr" title="Delete routes from the file">Routes</button> <button class="method-button svelte-ha7zfr" title="Reformat the config and remove the sections the SPA never reads">Clean up</button> <button role="tab">Configurator</button></div> <div class="modal-body svelte-ha7zfr"><!> <!> <!> <!></div> <div class="modal-footer svelte-ha7zfr"><span class="build-sha svelte-ha7zfr">__BUILD_SHA__</span> <div class="modal-footer-actions svelte-ha7zfr"><!></div></div></div>`);
var root_42 = $.from_html(`<div class="modal-overlay svelte-ha7zfr" role="button" tabindex="0" aria-label="Close configuration dialog"><!></div>`);

const $$css = {
	hash: 'svelte-ha7zfr',
	code: '.modal-overlay.svelte-ha7zfr {position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0, 0, 0, 0.5);display:flex;align-items:center;justify-content:center;z-index:10000;}.config-method-selector.svelte-ha7zfr {display:flex;gap:0.5rem;margin-bottom:1rem;border-bottom:2px solid #e5e7eb;overflow-x:auto;-webkit-overflow-scrolling:touch;flex-wrap:nowrap;padding-bottom:2px;}[data-theme="dark"] .config-method-selector.svelte-ha7zfr {border-bottom-color:#374151;}.method-button.svelte-ha7zfr {padding:0.75rem 1rem;background:none;border:none;border-bottom:2px solid transparent;cursor:pointer;font-weight:500;color:#6b7280;transition:all 0.2s;margin-bottom:-2px;flex-shrink:0;}.method-button.svelte-ha7zfr:hover {color:#111827;}.method-button.svelte-ha7zfr:disabled {opacity:0.5;cursor:not-allowed;}.delete-route-label.svelte-ha7zfr {margin-top:0.5rem;margin-bottom:0.25rem;}.delete-hint.svelte-ha7zfr {color:#6b7280;font-size:0.9rem;margin-bottom:1rem;}.delete-list.svelte-ha7zfr {display:flex;flex-direction:column;gap:0.5rem;max-height:320px;overflow:auto;border:1px solid #e5e7eb;border-radius:0.5rem;padding:0.75rem;background:#f9fafb;}[data-theme="dark"] .delete-list.svelte-ha7zfr {border-color:#374151;background:#111827;}.delete-item.svelte-ha7zfr {display:flex;align-items:center;gap:0.5rem;font-size:0.95rem;}.delete-checkbox.svelte-ha7zfr {width:1.1rem;height:1.1rem;}.delete-item-label.svelte-ha7zfr {font-weight:500;}.delete-confirm.svelte-ha7zfr {border:1px solid #e5e7eb;border-radius:0.5rem;padding:0.75rem;background:#fff7ed;}[data-theme="dark"] .delete-confirm.svelte-ha7zfr {border-color:#374151;background:#1f2937;}.delete-confirm.svelte-ha7zfr h3:where(.svelte-ha7zfr) {margin-top:0;}.delete-confirm.svelte-ha7zfr ul:where(.svelte-ha7zfr) {margin:0;padding-left:1.25rem;}.delete-routes-hint.svelte-ha7zfr {color:#6b7280;font-size:0.9rem;margin-bottom:1rem;}.delete-routes-empty.svelte-ha7zfr {color:#6b7280;font-style:italic;}.delete-routes-list.svelte-ha7zfr {display:flex;flex-direction:column;gap:0.5rem;max-height:320px;overflow:auto;border:1px solid #e5e7eb;border-radius:0.5rem;padding:0.75rem;background:#f9fafb;}[data-theme="dark"] .delete-routes-list.svelte-ha7zfr {border-color:#374151;background:#111827;}.delete-routes-item.svelte-ha7zfr {padding:0.25rem 0;}.delete-routes-label.svelte-ha7zfr {font-weight:500;}.delete-routes-path.svelte-ha7zfr {font-size:0.8em;font-weight:400;color:#6b7280;margin-left:0.35em;}[data-theme="dark"] .delete-routes-path.svelte-ha7zfr {color:#9ca3af;}.delete-confirm.svelte-ha7zfr .delete-routes-path:where(.svelte-ha7zfr) {margin-left:0.25em;}.delete-disabled.svelte-ha7zfr {color:#6b7280;padding:0.75rem;border:1px dashed #d1d5db;border-radius:0.5rem;background:#f9fafb;}[data-theme="dark"] .delete-disabled.svelte-ha7zfr {border-color:#4b5563;background:#111827;}.method-button-active.svelte-ha7zfr {color:#087bc4;border-bottom-color:#087bc4;}[data-theme="dark"] .method-button.svelte-ha7zfr {color:#9ca3af;}[data-theme="dark"] .method-button.svelte-ha7zfr:hover {color:#f9fafb;}[data-theme="dark"] .method-button-active.svelte-ha7zfr {color:#60a5fa;border-bottom-color:#60a5fa;}\n\n  /* Lock body scroll when fullscreen editor is open (prevents scroll bleed on mobile) - CSS only via :has() */body:has(.fullscreen-editor-overlay) {overflow:hidden;overscroll-behavior:none;}.fullscreen-editor-overlay.svelte-ha7zfr {position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0, 0, 0, 0.8);z-index:11000;display:flex;align-items:stretch;justify-content:stretch;width:100vw;height:100vh;\n    /* iOS counts the address bar into 100vh; dvh is the visible height. */height:100dvh;overflow:hidden;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;}.fullscreen-editor-content.svelte-ha7zfr {background:white;border-radius:0;padding:8px;width:100vw;height:100vh;height:100dvh;display:flex;flex-direction:column;box-shadow:none;border:4px solid #087bc4;box-sizing:border-box;gap:8px;overflow:hidden;overscroll-behavior:contain;min-height:0;}\n\n  @media (min-width: 600px) {.fullscreen-editor-content.svelte-ha7zfr {padding:24px;}\n  }[data-theme="dark"] .fullscreen-editor-content.svelte-ha7zfr {border:4px solid #60a5fa;}.fullscreen-close.svelte-ha7zfr {align-self:flex-end;min-width:100px;font-size:1.1rem;margin:1rem;z-index:1;}.fullscreen-textarea.svelte-ha7zfr {flex:1 1 0;width:100%;height:100%;min-height:0;font-family:monospace;font-size:1rem;padding:0.5rem;border:none;border-radius:0;resize:none;box-sizing:border-box;background:#f9fafb;color:#111827;outline:none;overflow-x:auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;white-space:pre;word-break:normal;}.tweak-overlay.svelte-ha7zfr {position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0, 0, 0, 0.8);z-index:11000;display:flex;align-items:stretch;justify-content:stretch;width:100vw;height:100vh;height:100dvh;}.tweak-overlay-content.svelte-ha7zfr {background:white;width:100%;height:100%;display:flex;flex-direction:column;padding:8px;box-sizing:border-box;gap:0;border:4px solid #087bc4;overflow:hidden;min-height:0;}[data-theme="dark"] .tweak-overlay-content.svelte-ha7zfr {background:#1d232a;color:#f9fafb;border-color:#60a5fa;}.tweak-close-bar.svelte-ha7zfr {position:sticky;top:0;z-index:2;flex-shrink:0;display:flex;align-items:center;gap:0.5rem;padding:8px 0;background:inherit;}.tweak-filter-wrap.svelte-ha7zfr {flex:1;min-width:0;position:relative;display:flex;align-items:center;}.tweak-filter-input.svelte-ha7zfr {width:100%;min-width:0;padding:0.5rem 0.75rem;padding-right:2rem;font-size:1rem;border:1px solid #d1d5db;border-radius:0.375rem;box-sizing:border-box;}.tweak-filter-input.svelte-ha7zfr::placeholder {color:#9ca3af;}[data-theme="dark"] .tweak-filter-input.svelte-ha7zfr {background:#111827;border-color:#4b5563;color:#f9fafb;}[data-theme="dark"] .tweak-filter-input.svelte-ha7zfr::placeholder {color:#6b7280;}.tweak-filter-clear.svelte-ha7zfr {position:absolute;right:0.4rem;top:50%;transform:translateY(-50%);width:1.5rem;height:1.5rem;padding:0;display:flex;align-items:center;justify-content:center;font-size:1.25rem;line-height:1;color:#6b7280;background:transparent;border:none;border-radius:0.25rem;cursor:pointer;}.tweak-filter-clear.svelte-ha7zfr:hover {color:#111827;background:#e5e7eb;}[data-theme="dark"] .tweak-filter-clear.svelte-ha7zfr {color:#9ca3af;}[data-theme="dark"] .tweak-filter-clear.svelte-ha7zfr:hover {color:#f9fafb;background:#4b5563;}.tweak-close.svelte-ha7zfr {min-width:100px;font-size:1.1rem;flex-shrink:0;}.tweak-list.svelte-ha7zfr {flex:1 1 auto;display:flex;flex-direction:column;gap:0.9rem;padding-bottom:1rem;overflow:auto;min-height:0;}.tweak-empty.svelte-ha7zfr {margin:0;color:#6b7280;}[data-theme="dark"] .tweak-empty.svelte-ha7zfr {color:#9ca3af;}.tweak-section.svelte-ha7zfr {display:flex;flex-direction:column;gap:0.45rem;}.tweak-section-title.svelte-ha7zfr {margin:0;font-size:1.1rem;font-weight:700;}.tweak-section-context.svelte-ha7zfr {font-weight:400;color:#6b7280;font-size:0.95rem;}[data-theme="dark"] .tweak-section-context.svelte-ha7zfr {color:#9ca3af;}.tweak-entries.svelte-ha7zfr {list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:0.3rem;}.tweak-entry.svelte-ha7zfr {display:grid;grid-template-rows:auto auto;gap:0.15rem;padding:0.3rem 0;border-bottom:1px solid #e5e7eb;}[data-theme="dark"] .tweak-entry.svelte-ha7zfr {border-bottom-color:#374151;}.tweak-key.svelte-ha7zfr {font-size:0.9rem;font-weight:500;color:#374151;}.tweak-key-context.svelte-ha7zfr {font-weight:400;color:#6b7280;font-size:0.85rem;}[data-theme="dark"] .tweak-key.svelte-ha7zfr {color:#9ca3af;}[data-theme="dark"] .tweak-key-context.svelte-ha7zfr {color:#6b7280;}.tweak-value.svelte-ha7zfr {width:100%;min-width:0;padding:0.3rem;font-size:1rem;border:1px solid #d1d5db;border-radius:0.375rem;box-sizing:border-box;}[data-theme="dark"] .tweak-value.svelte-ha7zfr {background:#111827;border-color:#4b5563;color:#f9fafb;}.modal-content.svelte-ha7zfr {background:white;border-radius:0.5rem;padding:1.5rem;max-width:90vw;max-height:90vh;min-height:500px;width:800px;display:flex;flex-direction:column;box-shadow:0 20px 25px -5px rgba(0, 0, 0, 0.1);overflow:hidden; /* Prevent content from overflowing */}\n\n  /**\n   * On a phone the dialog is the editor: it takes the whole screen and the\n   * chrome around the text area shrinks, so typing does not happen in a sliver.\n   */\n  @media (max-width: 640px), (max-height: 620px) {.modal-content.svelte-ha7zfr {width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;min-height:0;border-radius:0;padding:0.75rem;}.modal-header.svelte-ha7zfr {margin-bottom:0.5rem;}.modal-header.svelte-ha7zfr h2:where(.svelte-ha7zfr) {font-size:1.25rem;}.page-row.svelte-ha7zfr {padding:0.4rem 0.6rem;margin-bottom:0.5rem;}.modal-body.svelte-ha7zfr > p:where(.svelte-ha7zfr) {font-size:0.85rem;margin-bottom:0.4rem;}.config-textarea.svelte-ha7zfr {font-size:0.8rem;padding:0.5rem;}.modal-body.svelte-ha7zfr {margin-bottom:0.5rem;}.modal-footer.svelte-ha7zfr {padding-top:0.25rem;}\n  }[data-theme="dark"] .modal-content.svelte-ha7zfr {background:#1d232a;color:#f9fafb;}.modal-header.svelte-ha7zfr {display:flex;justify-content:space-between;align-items:center;margin-bottom:1rem;}.modal-header.svelte-ha7zfr h2:where(.svelte-ha7zfr) {margin:0;font-size:1.5rem;font-weight:700;}.close-button.svelte-ha7zfr {background:none;border:none;font-size:2rem;cursor:pointer;padding:0;width:2rem;height:2rem;display:flex;align-items:center;justify-content:center;color:#6b7280;}.close-button.svelte-ha7zfr:hover {color:#111827;}[data-theme="dark"] .close-button.svelte-ha7zfr {color:#9ca3af;}[data-theme="dark"] .close-button.svelte-ha7zfr:hover {color:#f9fafb;}.modal-body.svelte-ha7zfr {flex:1 1 auto;display:flex;flex-direction:column;min-height:0; /* Critical for flexbox children to shrink */margin-bottom:1rem;overflow:hidden; /* Prevent body from scrolling, let textarea handle it */}\n\n  /* The configurator takes the screen the way the other screens do. */.configurator-panel.svelte-ha7zfr {width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;min-height:0;border-radius:0;padding:0.75rem;}.modal-body.svelte-ha7zfr p:where(.svelte-ha7zfr) {margin:0 0 0.75rem 0;flex-shrink:0; /* Don\'t shrink the label */}.error-message.svelte-ha7zfr {background-color:#fee2e2;border:1px solid #fca5a5;border-radius:0.375rem;padding:0.75rem;margin-bottom:0.75rem;color:#991b1b;font-size:0.875rem;flex-shrink:0;}[data-theme="dark"] .error-message.svelte-ha7zfr {background-color:#7f1d1d;border-color:#dc2626;color:#fca5a5;}.cleanup-review.svelte-ha7zfr {background-color:#eff6ff;border:1px solid #93c5fd;border-radius:0.375rem;padding:0.75rem;margin-bottom:0.75rem;color:#1e3a8a;font-size:0.875rem;flex-shrink:0;}[data-theme="dark"] .cleanup-review.svelte-ha7zfr {background-color:#1e3a8a;border-color:#3b82f6;color:#dbeafe;}.cleanup-review-title.svelte-ha7zfr {font-weight:600;margin-bottom:0.25rem;}.cleanup-review-actions.svelte-ha7zfr {display:flex;justify-content:flex-end;gap:0.5rem;margin-top:0.5rem;}.config-notice.svelte-ha7zfr {background-color:#ecfdf5;border:1px solid #6ee7b7;border-radius:0.375rem;padding:0.75rem;margin-bottom:0.75rem;color:#065f46;font-size:0.875rem;flex-shrink:0;}[data-theme="dark"] .config-notice.svelte-ha7zfr {background-color:#064e3b;border-color:#059669;color:#6ee7b7;}.page-row.svelte-ha7zfr {display:flex;align-items:center;gap:0.35rem;flex-wrap:nowrap;border:1px solid #e5e7eb;border-radius:0.5rem;padding:0.2rem 0.35rem;margin-bottom:0.35rem;background:#f9fafb;\n    /* The same reading width the routes below it keep on a wide screen. */width:100%;max-width:44rem;box-sizing:border-box;margin-left:auto;margin-right:auto;}.page-row.svelte-ha7zfr .button:where(.svelte-ha7zfr) {flex:0 0 auto;min-height:2.25rem;padding:0.2rem 0.6rem;font-size:0.75rem;}[data-theme="dark"] .page-row.svelte-ha7zfr {border-color:#374151;background:#111827;}.page-row-text.svelte-ha7zfr {display:flex;flex-direction:row;align-items:baseline;gap:0.35rem;flex:1 1 auto;min-width:0;font-size:0.8125rem;}.page-row-text.svelte-ha7zfr strong:where(.svelte-ha7zfr) {flex:0 0 auto;white-space:nowrap;}.page-row-hint.svelte-ha7zfr {color:#6b7280;font-size:0.7rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}[data-theme="dark"] .page-row-hint.svelte-ha7zfr {color:#9ca3af;}.page-row-form.svelte-ha7zfr {border:1px solid #e5e7eb;border-top:none;border-radius:0 0 0.5rem 0.5rem;padding:0.5rem 0.75rem 0.75rem;margin-top:-0.75rem;margin-bottom:0.75rem;background:#f9fafb;display:flex;flex-direction:column;gap:0.5rem;}[data-theme="dark"] .page-row-form.svelte-ha7zfr {border-color:#374151;background:#111827;}.on-the-run-fields.svelte-ha7zfr {display:grid;grid-template-columns:repeat(auto-fit, minmax(10rem, 1fr));gap:0.5rem 0.75rem;min-width:0;}.on-the-run-field.svelte-ha7zfr {display:flex;flex-direction:column;gap:0.15rem;font-size:0.8rem;min-width:0;}.on-the-run-label.svelte-ha7zfr {font-weight:500;}.on-the-run-field.svelte-ha7zfr input[type="number"]:where(.svelte-ha7zfr),\n  .on-the-run-field.svelte-ha7zfr input[type="text"]:where(.svelte-ha7zfr) {padding:0.3rem 0.45rem;border:1px solid #d1d5db;border-radius:0.375rem;font-size:0.85rem;width:100%;box-sizing:border-box;}.on-the-run-field.svelte-ha7zfr input[type="checkbox"]:where(.svelte-ha7zfr) {width:1.1rem;height:1.1rem;}[data-theme="dark"] .on-the-run-field.svelte-ha7zfr input[type="number"]:where(.svelte-ha7zfr),\n  [data-theme="dark"] .on-the-run-field.svelte-ha7zfr input[type="text"]:where(.svelte-ha7zfr) {background:#1f2937;border-color:#4b5563;color:#e5e7eb;}.on-the-run-hint.svelte-ha7zfr {color:#6b7280;font-size:0.72rem;}[data-theme="dark"] .on-the-run-hint.svelte-ha7zfr {color:#9ca3af;}.page-row-actions.svelte-ha7zfr {display:flex;justify-content:flex-end;gap:0.5rem;}.discard-question.svelte-ha7zfr {align-self:center;font-size:0.85rem;color:#6b7280;}[data-theme="dark"] .discard-question.svelte-ha7zfr {color:#9ca3af;}.button-danger {background-color:#dc2626;color:white;}.textarea-container.svelte-ha7zfr {flex:1 1 auto;display:flex;flex-direction:column;min-height:0;}.textarea-toolbar.svelte-ha7zfr {display:flex;gap:0.5rem;margin-bottom:0.5rem;flex-shrink:0;}.icon-button.svelte-ha7zfr {display:flex;align-items:center;gap:0.25rem;padding:0.5rem;background-color:#f3f4f6;border:1px solid #d1d5db;border-radius:0.375rem;cursor:pointer;transition:all 0.2s;position:relative;}.icon-button.svelte-ha7zfr:hover:not(:disabled) {background-color:#e5e7eb;border-color:#9ca3af;}.icon-button.svelte-ha7zfr:disabled {opacity:0.5;cursor:not-allowed;}[data-theme="dark"] .icon-button.svelte-ha7zfr {background-color:#374151;border-color:#4b5563;}[data-theme="dark"] .icon-button.svelte-ha7zfr:hover:not(:disabled) {background-color:#4b5563;border-color:#6b7280;}.icon.svelte-ha7zfr {width:1.25rem;height:1.25rem;fill:#111827;}.icon-button.svelte-ha7zfr img.icon:where(.svelte-ha7zfr) {object-fit:contain;width:1.5rem;height:1.5rem;}[data-theme="dark"] .icon-button.svelte-ha7zfr img.icon:where(.svelte-ha7zfr) {filter:invert(1);}[data-theme="dark"] .icon.svelte-ha7zfr {fill:#f9fafb;}.success-indicator.svelte-ha7zfr {color:#16a34a;font-weight:bold;font-size:1rem;}.error-indicator.svelte-ha7zfr {color:#dc2626;font-weight:bold;font-size:1rem;}[data-theme="dark"] .success-indicator.svelte-ha7zfr {color:#4ade80;}[data-theme="dark"] .error-indicator.svelte-ha7zfr {color:#f87171;}.config-textarea.error.svelte-ha7zfr {border-color:#dc2626;}[data-theme="dark"] .config-textarea.error.svelte-ha7zfr {border-color:#f87171;}.editor-stack.svelte-ha7zfr {position:relative;display:flex;flex:1 1 auto;min-height:0;}\n\n  /**\n   * The highlighted layer and the textarea must sit on exactly the same grid:\n   * same font, same padding, same border, same wrapping.\n   */.editor-highlight.svelte-ha7zfr,\n  .config-textarea.svelte-ha7zfr {font-family:monospace;font-size:0.875rem;line-height:1.5;padding:0.75rem;border:1px solid #d1d5db;border-radius:0.375rem;box-sizing:border-box;white-space:pre-wrap;overflow-wrap:break-word;tab-size:2;}.editor-highlight.svelte-ha7zfr {position:absolute;inset:0;margin:0;overflow:auto;color:#111827;border-color:transparent;pointer-events:none;}.config-textarea.svelte-ha7zfr {width:100%;flex:1 1 auto; /* Fill available space in modal-body */min-height:0; /* Critical for flexbox to work */resize:none; /* Disable manual resize, let flexbox handle it */overflow-y:auto; /* Scroll inside textarea if content is too long */background:transparent;color:transparent;caret-color:#111827;position:relative;}.config-textarea.svelte-ha7zfr::placeholder {color:#9ca3af;}.config-textarea.svelte-ha7zfr::selection {background:#bfdbfe;}.editor-highlight.svelte-ha7zfr .hljs-section {color:#087bc4;font-weight:600;}.editor-highlight.svelte-ha7zfr .hljs-attr {color:#0f766e;}.editor-highlight.svelte-ha7zfr .hljs-string {color:#b45309;}.editor-highlight.svelte-ha7zfr .hljs-number,\n  .editor-highlight.svelte-ha7zfr .hljs-literal {color:#7c3aed;}.editor-highlight.svelte-ha7zfr .hljs-comment {color:#6b7280;font-style:italic;}[data-theme="dark"] .editor-highlight.svelte-ha7zfr {color:#e5e7eb;}[data-theme="dark"] .config-textarea.svelte-ha7zfr {caret-color:#e5e7eb;border-color:#4b5563;}[data-theme="dark"] .editor-highlight.svelte-ha7zfr .hljs-section {color:#60a5fa;}[data-theme="dark"] .editor-highlight.svelte-ha7zfr .hljs-attr {color:#5eead4;}[data-theme="dark"] .editor-highlight.svelte-ha7zfr .hljs-string {color:#fcd34d;}[data-theme="dark"] .editor-highlight.svelte-ha7zfr .hljs-number,\n  [data-theme="dark"] .editor-highlight.svelte-ha7zfr .hljs-literal {color:#c4b5fd;}[data-theme="dark"] .editor-highlight.svelte-ha7zfr .hljs-comment {color:#9ca3af;}[data-theme="dark"] .config-textarea.svelte-ha7zfr {background:#111827;color:#f9fafb;border-color:#374151;}.modal-footer.svelte-ha7zfr {display:flex;align-items:center;gap:0.75rem;flex-shrink:0;margin-top:auto;}.build-sha.svelte-ha7zfr {font-size:0.75rem;color:#565f89;align-self:center;margin-right:auto;font-family:monospace;}[data-theme="dark"] .build-sha.svelte-ha7zfr {color:#6b7280;}.modal-footer-actions.svelte-ha7zfr {margin-left:auto;display:flex;gap:0.75rem;}\n\n  @media (max-width: 420px) {.modal-footer.svelte-ha7zfr {flex-direction:column;align-items:stretch;gap:0.5rem;}\n\n    /* On a narrow phone the commit gets its own row above the buttons. */.build-sha.svelte-ha7zfr {margin-right:0;}.modal-footer-actions.svelte-ha7zfr {margin-left:0;justify-content:flex-end;}\n  }.button-example.svelte-ha7zfr {background-color:#f3f4f6;color:#111827;border:1px solid #d1d5db;}.button-example.svelte-ha7zfr:hover:not(:disabled) {background-color:#e5e7eb;border-color:#9ca3af;}[data-theme="dark"] .button-example.svelte-ha7zfr {background-color:#374151;color:#f9fafb;border-color:#4b5563;}[data-theme="dark"] .button-example.svelte-ha7zfr:hover:not(:disabled) {background-color:#4b5563;border-color:#6b7280;}\n\n  /* Global: the configurator is a child component, and it wears the same\n     buttons as every other dialog screen. */.button {padding:0.5rem 1rem;border-radius:0.375rem;font-weight:500;cursor:pointer;border:none;transition:background-color 0.2s;}.button:disabled {opacity:0.5;cursor:not-allowed;}.button-primary {background-color:#087bc4;color:white;}.button-primary:hover:not(:disabled) {background-color:#0669a3;}.button-secondary {background-color:#e5e7eb;color:#111827;}.button-secondary:hover:not(:disabled) {background-color:#d1d5db;}[data-theme="dark"] .button-secondary {background-color:#374151;color:#f9fafb;}[data-theme="dark"] .button-secondary:hover:not(:disabled) {background-color:#4b5563;}'
};

export default function ConfigModal($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	/* eslint-disable svelte/prefer-svelte-reactivity */
	/* global HTMLInputElement, HTMLTextAreaElement, URL */
	let configText = $.state("");

	let view = $.state("toml");
	let errorMessage = $.state(null);
	let notice = $.state(null);

	/** The text the notice belongs to; any edit makes it stale. */
	let noticeFor = $.state("");

	/** A prepared clean-up the user has not applied yet. */
	let pendingCleanup = $.state(
		/** The text it was computed from; an edit elsewhere drops the proposal. */
		null
	);

	let isSaving = $.state(false);

	/** The text as it was loaded; anything else is an unsaved edit. */
	let savedText = $.state("");

	/** Set when leaving would throw edits away. */
	let confirmCancel = $.state(false);

	let isLoadingExample = $.state(false);
	let copySuccess = $.state(false);
	let pasteSuccess = $.state(false);
	let pasteError = $.state(false);
	let showWizard = $.state(false);
	let showDelete = $.state(false);
	let showDeleteRoutes = $.state(false);
	let deleteRoutesStep = $.state("select");
	let deleteRoutesSelections = $.state($.proxy(new Set()));
	let deleteStep = $.state("select");
	let deleteCandidates = $.state($.proxy([]));
	let deleteSelections = $.state($.proxy(new Set()));
	let deleteError = $.state(null);
	let deleteRouteLabel = $.state("");
	let deleteDisabled = $.state(false);
	let showFullscreenEditor = $.state(false);
	let showTweakOverlay = $.state(false);
	let tweakSections = $.state($.proxy([]));
	let wizardContext = $.state(null);
	const configStorage = new LocalStorageConfigStorage();
	const configParser = new ConfigParser();

	function extractStationIdFromBlock(block) {
		// Extract station_id from a [[stops]] block
		const match = block.match(/station_id\s*=\s*"([^"]+)"/);

		return match ? match[1] : null;
	}

	function extractStationNameFromBlock(block) {
		const match = block.match(/station_name\s*=\s*"([^"]+)"/);

		return match ? match[1] : null;
	}

	function getCurrentRoutePath() {
		const hash = window.location.hash.slice(1); // Remove leading #

		if (!hash || hash === "/") {
			return "/";
		}

		return hash;
	}

	function isOnTheRunRoute(path) {
		return path === "on-the-run" || path === "/on-the-run";
	}

	function openWizard() {
		$.set(wizardContext, getWizardConfigContext($.get(configText)), true);
		$.set(showWizard, true);
	}

	/** Leaving the configurator returns to the file; nothing is saved from here. */
	function closeConfigurator() {
		$.set(view, "toml");
	}

	function buildDeletableRoutes() {
		const items = [];

		if (!$.get(configText).trim()) return items;

		const lines = $.get(configText).split("\n");

		// Find [[routes]] blocks (exclude default "/" and on-the-run)
		let i = 0;

		while (i < lines.length) {
			if (lines[i].trim() === "[[routes]]") {
				const startLine = i;
				let path = "/";
				let title;

				i++;

				while (i < lines.length) {
					const line = lines[i];
					const trimmed = line.trim();
					const pathMatch = trimmed.match(/path\s*=\s*"([^"]*)"/) ?? trimmed.match(/path\s*=\s*'([^']*)'/);

					if (pathMatch) path = pathMatch[1];

					if (trimmed === "[[routes.display]]") {
						let j = i + 1;

						while (j < lines.length) {
							const t = lines[j].trim();

							if (t.startsWith("[[") || t.startsWith("[") && !t.startsWith("[routes")) break;

							const titleMatch = t.match(/title\s*=\s*"([^"]*)"/);

							if (titleMatch) {
								title = titleMatch[1];

								break;
							}

							j++;
						}
					}

					if (trimmed === "[[routes]]") break;
					if (trimmed.startsWith("[[") && !trimmed.startsWith("[[routes")) break;
					if (trimmed.match(/^\[[a-z_]+\]/) && !trimmed.startsWith("[routes")) break;

					i++;
				}

				const endLine = i;
				const normalizedPath = path.startsWith("/") ? path : `/${path}`;

				// Every page is deletable, "/" included; what a config cannot lose is
				// its last page, and the footer says so.
				if (!isOnTheRunRoute(normalizedPath)) {
					const displayLabel = title ?? normalizedPath;

					items.push({
						id: `route::${normalizedPath}`,
						label: displayLabel,
						path: normalizedPath,
						startLine,
						endLine
					});
				}

				continue;
			}

			i++;
		}

		return items;
	}

	const deletableConfigItems = $.derived(buildDeletableRoutes);

	/** The last page is what the app opens; removing it would leave nothing to show. */
	const deletingEveryRoute = $.derived(() => $.get(deletableConfigItems).length > 0 && $.get(deleteRoutesSelections).size >= $.get(deletableConfigItems).length);

	function toggleDeleteRoutesSelection(id) {
		const next = new Set($.get(deleteRoutesSelections));

		if (next.has(id)) {
			next.delete(id);
		} else {
			next.add(id);
		}

		$.set(deleteRoutesSelections, next, true);
	}

	function applyRoutesDeletions() {
		if ($.get(deleteRoutesSelections).size === 0) return;

		const itemsToDelete = $.get(deletableConfigItems).filter((item) => $.get(deleteRoutesSelections).has(item.id));

		if (itemsToDelete.length === 0) return;

		// Delete in reverse order (end to start) so line indices stay valid
		const sorted = [...itemsToDelete].sort((a, b) => b.startLine - a.startLine);

		let lines = $.get(configText).split("\n");

		for (const item of sorted) {
			const before = lines.slice(0, item.startLine);
			const after = lines.slice(item.endLine);

			lines = [...before, ...after];
		}

		$.set(configText, lines.join("\n").replace(/\n{3,}/g, "\n\n").trim(), true);
		$.set(deleteRoutesSelections, new Set(), true);
		$.set(deleteRoutesStep, "select");
		$.set(showDeleteRoutes, false);
	}

	function startDeleteRoutesFlow() {
		$.set(deleteRoutesStep, "select");
		$.set(deleteRoutesSelections, new Set(), true);
		$.set(showDeleteRoutes, true);
	}

	function buildDeleteCandidates() {
		if (!$.get(configText).trim()) {
			return {
				candidates: [],
				routeLabel: "",
				disabled: true,
				error: "No configuration found."
			};
		}

		try {
			const parsed = configParser.parseToml($.get(configText));
			const currentPath = getCurrentRoutePath();
			const route = parsed.routes.find((r) => r.path === currentPath) ?? (currentPath === "/" ? parsed.routes.find((r) => r.path === "/") : undefined);

			if (!route) {
				return {
					candidates: [],
					routeLabel: currentPath,
					disabled: true,
					error: "Current route not found in config."
				};
			}

			if (route.isOnTheRun || currentPath === "on-the-run") {
				return {
					candidates: [],
					routeLabel: route.display?.title ?? currentPath,
					disabled: true,
					error: "Delete is disabled for Next to me."
				};
			}

			const candidates = [];

			for (const stop of route.stops) {
				const stopName = stop.stationName;
				const stopId = stop.stationId;
				const directionKeys = Object.keys(stop.directionMappings ?? {});

				if (directionKeys.length > 0) {
					for (const directionName of directionKeys) {
						const displayDirection = directionName.replace(/^->\s*/, "");
						const label = `${stopName} → ${displayDirection}`;

						candidates.push({
							id: `${stopId}::direction::${directionName}`,
							stopId,
							stopName,
							kind: "direction",
							directionName,
							label
						});
					}
				}

				if (stop.showUngrouped) {
					const ungroupedTitle = stop.ungroupedTitle ?? "Other";
					const label = `${stopName} → ${ungroupedTitle}`;

					candidates.push({
						id: `${stopId}::ungrouped`,
						stopId,
						stopName,
						kind: "ungrouped",
						label
					});
				}

				if (directionKeys.length === 0 && stop.showUngrouped !== true) {
					candidates.push({
						id: `${stopId}::ungrouped`,
						stopId,
						stopName,
						kind: "ungrouped",
						label: stopName
					});
				}
			}

			return {
				candidates,
				routeLabel: route.display?.title ?? route.path ?? currentPath,
				disabled: false
			};
		} catch(error) {
			const message = error instanceof Error ? error.message : String(error);

			return {
				candidates: [],
				routeLabel: "",
				disabled: true,
				error: `Invalid TOML: ${message}`
			};
		}
	}

	function startDeleteFlow() {
		const result = buildDeleteCandidates();

		$.set(deleteCandidates, result.candidates, true);
		$.set(deleteRouteLabel, result.routeLabel, true);
		$.set(deleteDisabled, result.disabled, true);
		$.set(deleteError, result.error ?? null, true);
		$.set(deleteSelections, new Set(), true);
		$.set(deleteStep, "select");
		$.set(showDelete, true);
	}

	function toggleDeleteSelection(id) {
		const next = new Set($.get(deleteSelections));

		if (next.has(id)) {
			next.delete(id);
		} else {
			next.add(id);
		}

		$.set(deleteSelections, next, true);
	}

	function applyDeletions() {
		if ($.get(deleteSelections).size === 0) {
			return;
		}

		const currentPath = getCurrentRoutePath();
		const deletionsByStop = new Map();

		for (const candidate of $.get(deleteCandidates)) {
			if (!$.get(deleteSelections).has(candidate.id)) {
				continue;
			}

			const stopKey = `${candidate.stopId}::${candidate.stopName}`;

			if (!deletionsByStop.has(stopKey)) {
				deletionsByStop.set(stopKey, { directions: new Set(), removeUngrouped: false });
			}

			const entry = deletionsByStop.get(stopKey);

			if (candidate.kind === "direction" && candidate.directionName) {
				entry.directions.add(candidate.directionName);
			}

			if (candidate.kind === "ungrouped") {
				entry.removeUngrouped = true;
			}
		}

		const lines = $.get(configText).split("\n");
		const output = [];
		let currentRoutePathInBlock = null;
		let insideRouteBlock = false;
		let currentStopLines = null;
		let currentStopIsRouteStop = false;

		const flushStop = () => {
			if (!currentStopLines) {
				return;
			}

			const block = currentStopLines.join("\n");
			const stopId = extractStationIdFromBlock(block);
			const stopName = extractStationNameFromBlock(block);
			const stopKey = stopId && stopName ? `${stopId}::${stopName}` : null;
			const isDefaultRoute = currentPath === "/";
			const shouldModify = stopKey && deletionsByStop.has(stopKey) && (currentStopIsRouteStop && currentRoutePathInBlock === currentPath || !currentStopIsRouteStop && isDefaultRoute);

			if (!shouldModify) {
				output.push(block);
				currentStopLines = null;
				currentStopIsRouteStop = false;

				return;
			}

			const deletion = deletionsByStop.get(stopKey);

			if (!deletion) {
				output.push(block);
				currentStopLines = null;
				currentStopIsRouteStop = false;

				return;
			}

			const modified = applyStopDeletions(block, deletion);

			if (modified.keep) {
				output.push(modified.block);
			}

			currentStopLines = null;
			currentStopIsRouteStop = false;
		};

		const applyStopDeletions = (block, deletion) => {
			const lines = block.split("\n");
			const cleaned = [];
			let directionHeader = null;
			const directionLines = [];
			let inDirectionMappings = false;
			let hasMappingLines = false;
			let skipDeletedArrayDepth = 0;

			const countBrackets = (value) => {
				let depth = 0;

				for (const ch of value) {
					if (ch === "[") depth += 1;
					if (ch === "]") depth -= 1;
				}

				return depth;
			};

			for (const line of lines) {
				if (line.startsWith("[stops.direction_mappings]") || line.startsWith("[routes.stops.direction_mappings]")) {
					inDirectionMappings = true;
					directionHeader = line;

					continue;
				}

				if (inDirectionMappings) {
					if (skipDeletedArrayDepth > 0) {
						skipDeletedArrayDepth += countBrackets(line);

						if (skipDeletedArrayDepth <= 0) {
							skipDeletedArrayDepth = 0;
						}

						continue;
					}

					const trimmed = line.trim();

					if (trimmed.startsWith("#") || trimmed === "") {
						directionLines.push(line);

						continue;
					}

					const match = line.match(/^"([^"]+)"\s*=/);

					if (match && deletion.directions.has(match[1])) {
						const depth = countBrackets(line);

						if (depth > 0) {
							skipDeletedArrayDepth = depth;
						}

						continue;
					}

					directionLines.push(line);
					hasMappingLines = true;

					continue;
				}

				if (deletion.removeUngrouped) {
					if (line.startsWith("show_ungrouped")) {
						cleaned.push("show_ungrouped = false");

						continue;
					}

					if (line.startsWith("ungrouped_title")) {
						continue;
					}
				}

				cleaned.push(line);
			}

			if (directionHeader && directionLines.length > 0) {
				cleaned.push(directionHeader);
				cleaned.push(...directionLines);
			}

			const showUngroupedMatch = cleaned.find((line) => line.startsWith("show_ungrouped"));
			const showUngrouped = showUngroupedMatch?.includes("true") ?? false;
			const hasDirections = hasMappingLines;

			if (!showUngrouped && !hasDirections) {
				return { keep: false, block: "" };
			}

			return { keep: true, block: cleaned.join("\n") };
		};

		for (const line of lines) {
			if (line.startsWith("[[routes]]")) {
				flushStop();
				insideRouteBlock = true;
				currentRoutePathInBlock = null;
				output.push(line);

				continue;
			}

			if (line.startsWith("path =") && insideRouteBlock) {
				const match = line.match(/path\s*=\s*"([^"]+)"/);

				if (match) {
					currentRoutePathInBlock = match[1];
				}

				output.push(line);

				continue;
			}

			if (line.startsWith("[[routes.stops]]") || line.startsWith("[[stops]]")) {
				flushStop();
				currentStopLines = [line];
				currentStopIsRouteStop = line.startsWith("[[routes.stops]]");

				continue;
			}

			if (currentStopLines && (line.startsWith("[[") || line.startsWith("[") && !line.startsWith("[stops.direction_mappings]") && !line.startsWith("[routes.stops.direction_mappings]"))) {
				flushStop();
				output.push(line);

				continue;
			}

			if (currentStopLines) {
				currentStopLines.push(line);

				continue;
			}

			if (line.startsWith("[") && !line.startsWith("[routes") && !line.startsWith("[[routes")) {
				insideRouteBlock = false;
				currentRoutePathInBlock = null;
			}

			output.push(line);
		}

		flushStop();
		$.set(configText, output.join("\n").trim(), true);
		$.set(showDelete, false);
		$.set(deleteSelections, new Set(), true);
		$.set(deleteStep, "select");
	}

	/** True if the line is a TOML section header (not a comment; starts with [ and ends with ]). */
	function isSectionHeader(line) {
		const t = line.trim();

		return t.length > 0 && !t.startsWith("#") && t.startsWith("[") && t.endsWith("]");
	}

	/** Section heading text for display (trimmed, trailing # comment removed). */
	function sectionHeadingText(line) {
		return line.trim().replace(/\s*#.*$/, "").trim();
	}

	/** Parse all TOML sections: every non-comment line starting with [ is a heading; collect key=value lines until the next heading. */
	function parseDisplaySections(tomlText) {
		const lines = tomlText.split("\n");
		const sections = [];
		let i = 0;
		const keyValueRe = /^\s*([a-z][a-z0-9_]*)\s*=\s*(.*)$/;

		while (i < lines.length) {
			const line = lines[i];

			if (isSectionHeader(line)) {
				const heading = sectionHeadingText(line);
				const entries = [];

				i += 1;

				while (i < lines.length) {
					const next = lines[i];

					if (isSectionHeader(next)) {
						break;
					}

					const kv = next.match(keyValueRe);

					if (kv) {
						const [, key, raw] = kv;
						const rawTrimmed = raw.trim();
						const isNonScalar = rawTrimmed.startsWith("[") || rawTrimmed.startsWith("{");

						if (!isNonScalar) {
							let value = rawTrimmed;

							if (value.startsWith('"')) {
								let end = 1;

								while (end < value.length) {
									if (value[end] === "\\" && end + 1 < value.length) {
										end += 2;

										continue;
									}

									if (value[end] === '"') {
										value = value.slice(1, end).replace(/\\"/g, '"');

										break;
									}

									end += 1;
								}
							} else if (value.startsWith("'") && value.endsWith("'") && value.length >= 2) {
								value = value.slice(1, -1);
							} else {
								const hashIdx = value.indexOf("#");

								if (hashIdx !== -1) value = value.slice(0, hashIdx).trim();
							}

							entries.push({ key, value, lineIndex: i });
						}
					}

					i += 1;
				}

				sections.push({ heading, entries });

				continue;
			}

			i += 1;
		}

		return sections;
	}

	/** Format value for TOML: quote strings, leave numbers/booleans/arrays/inline tables as-is. */
	function tomlValue(value) {
		const trimmed = value.trim();

		if (trimmed === "true" || trimmed === "false") return trimmed;

		const n = Number(trimmed);

		if (!Number.isNaN(n) && trimmed !== "") return trimmed;
		if (trimmed.startsWith("[") || trimmed.startsWith("{")) return trimmed;

		return `"${trimmed.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
	}

	/** Apply modified tweak sections back to TOML text (updates config text only, does not save). */
	function applyTweakDisplay(tomlText, sections) {
		const lines = tomlText.split("\n");
		const lineUpdates = new Map();

		for (const section of sections) {
			for (const entry of section.entries) {
				const line = lines[entry.lineIndex];

				if (!line) continue;

				const keyValueRe = /^\s*([a-z][a-z0-9_]*)\s*=\s*(.*)$/;

				if (keyValueRe.test(line)) {
					lineUpdates.set(entry.lineIndex, `${entry.key} = ${tomlValue(entry.value)}`);
				}
			}
		}

		const out = [];

		for (let idx = 0; idx < lines.length; idx++) {
			out.push(lineUpdates.has(idx) ? lineUpdates.get(idx) : lines[idx]);
		}

		return out.join("\n");
	}

	function openTweak() {
		$.set(tweakSections, parseDisplaySections($.get(configText)), true);
		$.set(showTweakOverlay, true);
	}

	function closeTweakAndApply() {
		$.set(configText, applyTweakDisplay($.get(configText), $.get(tweakSections)), true);
		$.set(showTweakOverlay, false);
	}

	let tweakFilterQuery = $.state("");
	let tweakFilterInputEl = $.state(undefined);

	$.user_effect(() => {
		if (!$.get(showTweakOverlay)) return;

		tick().then(() => $.get(tweakFilterInputEl)?.focus());
	});

	let lastTweakValueFocusedEl = $.state(undefined);

	/** Identity of the value input that has focus (for keeping it visible while editing). */
	const lastTweakFocusedEntry = $.derived(() => {
		const el = $.get(lastTweakValueFocusedEl);

		if (!el?.id?.startsWith?.("tweak-input-")) return undefined;

		const match = el.id.match(/^tweak-input-(\d+)-(\d+)$/);

		if (!match) return undefined;

		return {
			sectionIdx: parseInt(match[1], 10),
			lineIndex: parseInt(match[2], 10)
		};
	});

	function clearTweakFilter() {
		$.set(tweakFilterQuery, "");

		tick().then(() => {
			if ($.get(lastTweakValueFocusedEl) && document.contains($.get(lastTweakValueFocusedEl))) {
				$.get(lastTweakValueFocusedEl).focus();
				$.get(lastTweakValueFocusedEl).scrollIntoView({ behavior: "smooth", block: "nearest" });
			} else {
				$.get(tweakFilterInputEl)?.focus();
			}
		});
	}

	/** Non-empty filter terms (lowercased) for AND matching. */
	const tweakFilterParts = $.derived(() => $.get(tweakFilterQuery).trim().split(/\s+/).filter(Boolean).map((p) => p.toLowerCase()));

	function tweakEntryMatchesFilter(entry, parts) {
		if (parts.length === 0) return true;

		const line = `${entry.key} ${entry.value}`.toLowerCase();

		return parts.every((part) => line.includes(part));
	}

	/** True if the section heading (e.g. on_the_run) matches all filter parts. */
	function tweakSectionHeadingMatchesFilter(section, parts) {
		if (parts.length === 0) return true;

		const heading = section.heading.toLowerCase();

		return parts.every((part) => heading.includes(part));
	}

	function tweakSectionHasVisibleEntries(section, parts, sectionIdx) {
		const focused = $.get(lastTweakFocusedEntry);

		if (focused?.sectionIdx === sectionIdx) {
			const hasFocusedEntry = section.entries.some((e) => e.lineIndex === focused.lineIndex);

			if (hasFocusedEntry) return true;
		}

		return tweakSectionHeadingMatchesFilter(section, parts) || section.entries.some((e) => tweakEntryMatchesFilter(e, parts));
	}

	/** Show entry if section heading matches (show whole section) or this entry's key/value matches.
	 * Always show the entry whose value input is focused, so editing (e.g. clearing) doesn't hide it. */
	function tweakShowEntry(section, entry, parts, sectionIdx) {
		const focused = $.get(lastTweakFocusedEntry);

		if (focused && focused.sectionIdx === sectionIdx && focused.lineIndex === entry.lineIndex) {
			return true;
		}

		return tweakSectionHeadingMatchesFilter(section, parts) || tweakEntryMatchesFilter(entry, parts);
	}

	/** Keys that appear in more than one section (for disambiguation in labels). */
	const tweakDuplicateKeys = $.derived(() => {
		const keyCount = new Map();

		for (const section of $.get(tweakSections)) {
			for (const entry of section.entries) {
				keyCount.set(entry.key, (keyCount.get(entry.key) ?? 0) + 1);
			}
		}

		return new Set([...keyCount.entries()].filter(([, n]) => n > 1).map(([k]) => k));
	});

	async function loadStoredConfig() {
		const storedToml = await configStorage.getConfigToml();

		$.set(configText, storedToml || "", true);
		$.set(savedText, $.get(configText), true);
		$.set(errorMessage, null // Clear error when loading
		);
		$.set(notice, null);
	}

	// Load raw TOML from storage when modal opens
	$.user_effect(() => {
		void loadStoredConfig();
	});

	// Clear error when text changes
	$.user_effect(() => {
		if ($.get(configText) && $.get(errorMessage)) {
			$.set(errorMessage, null);
		}

		if ($.get(notice) && $.get(configText) !== $.get(noticeFor)) {
			$.set(notice, null);
		}

		// Editing the text makes a prepared clean-up stale.
		if ($.get(pendingCleanup) && $.get(pendingCleanup).for !== $.get(configText)) {
			$.set(pendingCleanup, null);
		}
	});

	/** Says what just happened to the text; the change itself is not saved yet. */
	function showNotice(message) {
		$.set(notice, message, true);
		$.set(noticeFor, $.get(configText), true);
	}

	/**
	 * Rewrites the config into the SPA's shape - but only as a proposal: the
	 * rewrite lands in the editor when the user applies it, and Cancel leaves the
	 * text exactly as it was. Nothing is saved either way until Save.
	 *
	 * The rewrite removes lines and moves the legacy stops; everything else -
	 * comments, blank lines, the author's order - stays as it was written.
	 */
	function previewCleanup() {
		$.set(notice, null);

		try {
			const cleanup = cleanUpConfigToml($.get(configText));

			if (!cleanup.changed) {
				showNotice(describeCleanup(cleanup));

				return;
			}

			configParser.parseToml(cleanup.toml);

			$.set(
				pendingCleanup,
				{
					for: $.get(configText),
					toml: cleanup.toml,
					description: describeCleanup(cleanup)
				},
				true
			);
		} catch(error) {
			const message = error instanceof Error ? error.message : String(error);

			$.set(errorMessage, `Could not clean up the configuration: ${message}`);
		}
	}

	function applyCleanup() {
		if (!$.get(pendingCleanup)) {
			return;
		}

		const { toml, description } = $.get(pendingCleanup);

		$.set(pendingCleanup, null);
		$.set(configText, toml, true);
		$.set(errorMessage, null);
		showNotice(description);
	}

	/** The mode row's Clean up: prepare the rewrite, then show it where it lands. */
	function startCleanup() {
		$.set(view, "toml");
		previewCleanup();
	}

	function cancelCleanup() {
		$.set(pendingCleanup, null);
	}

	/** The TOML as highlighted HTML, painted behind the (transparent) textarea. */
	const highlightedToml = $.derived(() => `${highlightToml($.get(configText))}\n`);

	let highlightLayer = $.state(null);

	function syncEditorScroll(event) {
		const area = event.currentTarget;

		if ($.get(highlightLayer) === null) {
			return;
		}

		$.get(highlightLayer).scrollTop = area.scrollTop;
		$.get(highlightLayer).scrollLeft = area.scrollLeft;
	}

	const hasOnTheRunPage = $.derived(() => hasOnTheRun($.get(configText)));

	/** The Next to me page's own settings, and its open form. */
	const onTheRunSettings = $.derived(() => readOnTheRunSettings($.get(configText)));

	let onTheRunDraft = $.state(null);

	function openOnTheRunForm() {
		$.set(onTheRunDraft, draftOfOnTheRun($.get(onTheRunSettings)), true);
	}

	function applyOnTheRun() {
		if ($.get(onTheRunDraft) === null) {
			return;
		}

		const values = settingsOfOnTheRunDraft($.get(onTheRunDraft));
		const before = $.get(configText);

		$.set(onTheRunDraft, null);
		$.set(configText, updateOnTheRunSettings($.get(configText), values), true);

		if ($.get(configText) !== before) {
			showNotice("Next to me updated. Save to keep the change.");
		}
	}

	/** The pages the config describes, in file order. */
	const configPages = $.derived(() => readConfigPages($.get(configText)));

	/** The settings every page inherits. */
	const globalDisplay = $.derived(() => readDisplaySettings($.get(configText), "global"));

	function reorderPage(from, to) {
		$.set(configText, moveConfigPage($.get(configText), from, to), true);
		showNotice("Pages reordered. Save to keep the new order.");
	}

	function deletePage(index) {
		const page = $.get(configPages)[index];

		if (!page) {
			return;
		}

		$.set(configText, removeConfigPage($.get(configText), index), true);
		showNotice(`Deleted the page “${page.title}”. Save to keep the change.`);
	}

	/** Applies one page's form; the file only moves when a value really differs. */
	function applyPageEdit(index, edit) {
		const before = $.get(configText);

		$.set(configText, updateConfigPage($.get(configText), index, edit), true);

		if ($.get(configText) !== before) {
			showNotice("Page settings updated. Save to keep the change.");
		}
	}

	/** The display settings of one page, which win over the file's defaults. */
	function applyPageDisplay(index, values) {
		const before = $.get(configText);

		$.set(configText, updateDisplaySettings($.get(configText), index, values), true);

		if ($.get(configText) !== before) {
			showNotice("Page settings updated. Save to keep the change.");
		}
	}

	/** Adds an empty page after the last one; the card says what to do next. */
	function addPage(page) {
		const before = $.get(configText);

		$.set(configText, addConfigPage($.get(configText), page), true);

		if ($.get(configText) === before) {
			showNotice(`A page already uses the path ${page.path}.`);

			return;
		}

		showNotice(`Added the page “${page.title || page.path}”. Add stops to it, then save.`);
	}

	/** The settings every page inherits. */
	function applyDefaults(values) {
		const before = $.get(configText);

		$.set(configText, updateDisplaySettings($.get(configText), "global", values), true);

		if ($.get(configText) !== before) {
			showNotice("Defaults updated. Save to keep the change.");
		}
	}

	function deleteStop(pageIndex, stopIndex) {
		const page = $.get(configPages)[pageIndex];
		const stop = page?.stops[stopIndex];

		if (!page || !stop) {
			return;
		}

		$.set(configText, removeConfigStop($.get(configText), pageIndex, stopIndex), true);
		showNotice(`Deleted “${stop.name}” from “${page.title}”. Save to keep the change.`);
	}

	/** One stop's settings; the page's other stops stay as they are. */
	function applyStopEdit(pageIndex, stopIndex, edit) {
		const before = $.get(configText);

		$.set(configText, updateConfigStop($.get(configText), pageIndex, stopIndex, edit), true);

		if ($.get(configText) !== before) {
			showNotice("Stop settings updated. Save to keep the change.");
		}
	}

	function addStop(pageIndex, stop) {
		const before = $.get(configText);

		$.set(configText, addConfigStop($.get(configText), pageIndex, stop), true);

		if ($.get(configText) === before) {
			showNotice(`${stop.stationName} is already on this page.`);

			return;
		}

		showNotice(`Added “${stop.stationName}”. Save to keep the change.`);
	}

	/** Puts the page back when it went missing; it is never removed from here. */
	function restoreOnTheRun() {
		$.set(configText, addOnTheRunSection($.get(configText)), true);
		showNotice("Next to me is back with its default settings. Adjust them in the text, then save.");
	}

	async function loadExampleConfig() {
		$.set(isLoadingExample, true);
		$.set(errorMessage, null);

		try {
			// Use relative path to work with both root and subdirectory deployments
			const configPath = "./config.example.toml";

			const response = await fetch(configPath);

			if (response.ok) {
				const exampleToml = await response.text();

				$.set(configText, exampleToml, true);
				console.log(`Loaded example config from ${configPath}`);
			} else {
				$.set(errorMessage, `Failed to load example config: ${response.status} ${response.statusText}`);
				console.error("Failed to fetch example config:", response.status, response.statusText);
			}
		} catch(error) {
			const message = error instanceof Error ? error.message : String(error);

			$.set(errorMessage, `Failed to load example config: ${message}`);
			console.error("Failed to load example config:", error);
		} finally {
			$.set(isLoadingExample, false);
		}
	}

	async function handleSave() {
		if (!$.get(configText).trim()) {
			return;
		}

		// Validate TOML syntax and parsing before saving
		$.set(errorMessage, null);

		$.set(isSaving, true);

		try {
			// Try to parse the TOML to validate it
			configParser.parseToml($.get(configText));

			// If parsing succeeds, call onSave
			await $$props.onSave($.get(configText));

			// onSave will close the modal on success
		} catch(error) {
			// Extract error message
			const message = error instanceof Error ? error.message : String(error);

			$.set(errorMessage, `Invalid TOML configuration: ${message}`);
			console.error("Config validation failed:", error);

			// Don't close modal, let user fix the error
		} finally {
			$.set(isSaving, false);
		}
	}

	/**
	 * Leaving with unsaved edits asks once: a mis-tap next to Save should not
	 * throw away a reordered page or a new heading.
	 */
	function requestCancel() {
		if ($.get(configText) !== $.get(savedText)) {
			$.set(confirmCancel, true);

			return;
		}

		$$props.onCancel();
	}

	function handleKeydown(event) {
		if (event.key === "Escape") {
			requestCancel();

			return;
		}

		if (event.target !== event.currentTarget) {
			return;
		}

		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			requestCancel();
		}
	}

	async function handleCopy() {
		try {
			await navigator.clipboard.writeText($.get(configText));
			$.set(copySuccess, true);

			setTimeout(
				() => {
					$.set(copySuccess, false);
				},
				2000
			);
		} catch(error) {
			console.error("Failed to copy to clipboard:", error);
			$.set(errorMessage, "Failed to copy to clipboard. Please try manually selecting and copying.");
		}
	}

	async function handlePaste() {
		let text;

		try {
			text = (await navigator.clipboard.readText()).trim();
		} catch(error) {
			console.error("Failed to read the clipboard:", error);
			$.set(errorMessage, "Could not read the clipboard. Please paste manually.");

			return;
		}

		if (!text) {
			$.set(errorMessage, "Clipboard is empty. Please copy a valid TOML config.");
			flashPaste(false);

			return;
		}

		let contentToUse;

		try {
			contentToUse = await readPastedConfig(text);
		} catch(error) {
			const message = error instanceof Error ? error.message : String(error);

			$.set(errorMessage, `Could not load the pasted link: ${message}`);
			flashPaste(false);

			return;
		}

		try {
			configParser.parseToml(contentToUse);
			$.set(configText, contentToUse, true);
			$.set(errorMessage, null);
			flashPaste(true);
		} catch(error) {
			console.error("Failed to paste from clipboard:", error);
			$.set(errorMessage, "Clipboard does not contain valid TOML configuration.");
			flashPaste(false);
		}
	}

	/**
	 * A pasted link is fetched - GitHub's file pages through their raw host, the
	 * same way `?config=` is handled. Anything that is not a link is TOML text.
	 */
	async function readPastedConfig(text) {
		const url = parseHttpUrl(text);

		if (!url) {
			return text;
		}

		return fetchToml(rawConfigUrl(url) ?? url.href);
	}

	function parseHttpUrl(text) {
		try {
			const url = new globalThis.URL(text);

			return url.protocol === "http:" || url.protocol === "https:" ? url : null;
		} catch {
			return null;
		}
	}

	function flashPaste(success) {
		$.set(pasteSuccess, success, true);
		$.set(pasteError, !success);

		setTimeout(
			() => {
				$.set(pasteSuccess, false);
				$.set(pasteError, false);
			},
			2000
		);
	}

	async function handleWizardComplete(result) {
		// Build TOML config from wizard result
		// Preserve existing layout and only update the target section
		try {
			const existingConfig = $.get(configText);

			if (existingConfig.trim()) {
				configParser.parseToml(existingConfig);
			}

			const updatedConfig = applyWizardConfig(existingConfig, result);

			$.set(configText, updatedConfig.trim(), true);
			$.set(showWizard, false);
			$.set(errorMessage, null // Clear any previous errors
			);

			// Don't auto-save - let user review the generated config first
		} catch(error) {
			$.set(errorMessage, error instanceof Error ? error.message : "Failed to generate config", true);
			console.error("Wizard completion error:", error);
		}
	}

	var div = root_42();
	var node = $.child(div);

	{
		var consequent = ($$anchor) => {
			{
				let $0 = $.derived(() => $.get(wizardContext)?.routeStopIdsByPath ?? {});
				let $1 = $.derived(() => isOnTheRunRoute(getCurrentRoutePath()));

				ConfigWizard($$anchor, {
					onComplete: handleWizardComplete,
					onCancel: () => $.set(showWizard, false),
					get routeStopIdsByPath() {
						return $.get($0);
					},

					get onTheRunDisabled() {
						return $.get($1);
					}
				});
			}
		};

		var consequent_7 = ($$anchor) => {
			var div_1 = root_10();
			var div_2 = $.child(div_1);
			var button = $.sibling($.child(div_2), 2);

			$.reset(div_2);

			var div_3 = $.sibling(div_2, 2);
			var node_1 = $.sibling($.child(div_3), 2);

			{
				var consequent_1 = ($$anchor) => {
					var p_1 = root();

					$.append($$anchor, p_1);
				};

				var alternate = ($$anchor) => {
					var fragment_1 = root_6();
					var node_2 = $.first_child(fragment_1);

					{
						var consequent_2 = ($$anchor) => {
							var p_2 = root_1();

							$.append($$anchor, p_2);
						};

						$.if(node_2, ($$render) => {
							if ($.get(deletingEveryRoute)) $$render(consequent_2);
						});
					}

					var node_3 = $.sibling(node_2, 2);

					{
						var consequent_3 = ($$anchor) => {
							var div_4 = root_3();

							$.each(div_4, 21, () => $.get(deletableConfigItems), (item) => item.id, ($$anchor, item) => {
								var label_1 = root_2();
								var input = $.child(label_1);

								$.remove_input_defaults(input);

								var span = $.sibling(input, 2);
								var text_1 = $.child(span);
								var span_1 = $.sibling(text_1);
								var text_2 = $.only_child(span_1, true);

								$.reset(span);
								$.reset(label_1);

								$.template_effect(
									($0) => {
										$.set_checked(input, $0);
										$.set_text(text_1, `${$.get(item).label ?? ''} `);
										$.set_text(text_2, $.get(item).path);
									},
									[() => $.get(deleteRoutesSelections).has($.get(item).id)]
								);

								$.delegated('change', input, () => toggleDeleteRoutesSelection($.get(item).id));
								$.append($$anchor, label_1);
							});

							$.reset(div_4);
							$.append($$anchor, div_4);
						};

						var consequent_4 = ($$anchor) => {
							var div_5 = root_5();
							var ul = $.sibling($.child(div_5), 2);

							$.each(ul, 21, () => $.get(deletableConfigItems).filter((item) => $.get(deleteRoutesSelections).has(item.id)), (item) => item.id, ($$anchor, item) => {
								var li = root_4();
								var text_3 = $.child(li);
								var span_2 = $.sibling(text_3);
								var text_4 = $.only_child(span_2, true);

								$.reset(li);

								$.template_effect(() => {
									$.set_text(text_3, `${$.get(item).label ?? ''} `);
									$.set_text(text_4, $.get(item).path);
								});

								$.append($$anchor, li);
							});

							$.reset(ul);
							$.reset(div_5);
							$.append($$anchor, div_5);
						};

						$.if(node_3, ($$render) => {
							if ($.get(deleteRoutesStep) === "select") $$render(consequent_3); else if ($.get(deleteRoutesStep) === "confirm") $$render(consequent_4, 1);
						});
					}

					$.append($$anchor, fragment_1);
				};

				$.if(node_1, ($$render) => {
					if ($.get(deletableConfigItems).length === 0) $$render(consequent_1); else $$render(alternate, -1);
				});
			}

			$.reset(div_3);

			var node_4 = $.sibling(div_3, 2);

			{
				var consequent_6 = ($$anchor) => {
					var div_6 = root_9();
					var node_5 = $.child(div_6);

					{
						var consequent_5 = ($$anchor) => {
							var fragment_2 = root_7();
							var button_1 = $.first_child(fragment_2);
							var button_2 = $.sibling(button_1, 2);
							var button_3 = $.sibling(button_2, 2);

							$.template_effect(() => button_3.disabled = $.get(deleteRoutesSelections).size === 0 || $.get(deletingEveryRoute));
							$.delegated('click', button_1, () => $.set(deleteRoutesStep, "select"));
							$.delegated('click', button_2, () => $.set(showDeleteRoutes, false));
							$.delegated('click', button_3, applyRoutesDeletions);
							$.append($$anchor, fragment_2);
						};

						var alternate_1 = ($$anchor) => {
							var fragment_3 = root_8();
							var button_4 = $.first_child(fragment_3);
							var button_5 = $.sibling(button_4, 2);

							$.template_effect(() => button_5.disabled = $.get(deleteRoutesSelections).size === 0 || $.get(deletingEveryRoute));
							$.delegated('click', button_4, () => $.set(showDeleteRoutes, false));
							$.delegated('click', button_5, () => $.set(deleteRoutesStep, "confirm"));
							$.append($$anchor, fragment_3);
						};

						$.if(node_5, ($$render) => {
							if ($.get(deleteRoutesStep) === "confirm") $$render(consequent_5); else $$render(alternate_1, -1);
						});
					}

					$.reset(div_6);
					$.append($$anchor, div_6);
				};

				$.if(node_4, ($$render) => {
					if ($.get(deletableConfigItems).length > 0) $$render(consequent_6);
				});
			}

			$.reset(div_1);
			$.delegated('click', button, () => $.set(showDeleteRoutes, false));
			$.append($$anchor, div_1);
		};

		var consequent_14 = ($$anchor) => {
			var div_7 = root_17();
			var div_8 = $.child(div_7);
			var button_6 = $.sibling($.child(div_8), 2);

			$.reset(div_8);

			var div_9 = $.sibling(div_8, 2);
			var p_3 = $.child(div_9);
			var strong = $.sibling($.child(p_3));
			var text_5 = $.only_child(strong, true);

			$.reset(p_3);

			var node_6 = $.sibling(p_3, 4);

			{
				var consequent_8 = ($$anchor) => {
					var div_10 = root_11();
					var text_6 = $.only_child(div_10, true);

					$.template_effect(() => $.set_text(text_6, $.get(deleteError)));
					$.append($$anchor, div_10);
				};

				$.if(node_6, ($$render) => {
					if ($.get(deleteError)) $$render(consequent_8);
				});
			}

			var node_7 = $.sibling(node_6, 2);

			{
				var consequent_9 = ($$anchor) => {
					var div_11 = root_12();

					$.append($$anchor, div_11);
				};

				var consequent_10 = ($$anchor) => {
					var div_12 = root_13();

					$.append($$anchor, div_12);
				};

				var alternate_2 = ($$anchor) => {
					var fragment_4 = $.comment();
					var node_8 = $.first_child(fragment_4);

					{
						var consequent_11 = ($$anchor) => {
							var div_13 = root_15();

							$.each(div_13, 21, () => $.get(deleteCandidates), (item) => item.id, ($$anchor, item) => {
								var label_2 = root_14();
								var input_1 = $.child(label_2);

								$.remove_input_defaults(input_1);

								var span_3 = $.sibling(input_1, 2);
								var text_7 = $.only_child(span_3, true);

								$.reset(label_2);

								$.template_effect(
									($0) => {
										$.set_checked(input_1, $0);
										$.set_text(text_7, $.get(item).label);
									},
									[() => $.get(deleteSelections).has($.get(item).id)]
								);

								$.delegated('change', input_1, () => toggleDeleteSelection($.get(item).id));
								$.append($$anchor, label_2);
							});

							$.reset(div_13);
							$.append($$anchor, div_13);
						};

						var consequent_12 = ($$anchor) => {
							var div_14 = root_5();
							var ul_1 = $.sibling($.child(div_14), 2);

							$.each(ul_1, 21, () => $.get(deleteCandidates).filter((c) => $.get(deleteSelections).has(c.id)), (item) => item.id, ($$anchor, item) => {
								var li_1 = root_16();
								var text_8 = $.only_child(li_1, true);

								$.template_effect(() => $.set_text(text_8, $.get(item).label));
								$.append($$anchor, li_1);
							});

							$.reset(ul_1);
							$.reset(div_14);
							$.append($$anchor, div_14);
						};

						$.if(node_8, ($$render) => {
							if ($.get(deleteStep) === "select") $$render(consequent_11); else if ($.get(deleteStep) === "confirm") $$render(consequent_12, 1);
						});
					}

					$.append($$anchor, fragment_4);
				};

				$.if(node_7, ($$render) => {
					if ($.get(deleteDisabled)) $$render(consequent_9); else if ($.get(deleteCandidates).length === 0) $$render(consequent_10, 1); else $$render(alternate_2, -1);
				});
			}

			$.reset(div_9);

			var div_15 = $.sibling(div_9, 2);
			var node_9 = $.child(div_15);

			{
				var consequent_13 = ($$anchor) => {
					var fragment_5 = root_7();
					var button_7 = $.first_child(fragment_5);
					var button_8 = $.sibling(button_7, 2);
					var button_9 = $.sibling(button_8, 2);

					$.template_effect(() => button_9.disabled = $.get(deleteSelections).size === 0);
					$.delegated('click', button_7, () => $.set(deleteStep, "select"));
					$.delegated('click', button_8, () => $.set(showDelete, false));
					$.delegated('click', button_9, applyDeletions);
					$.append($$anchor, fragment_5);
				};

				var alternate_3 = ($$anchor) => {
					var fragment_6 = root_8();
					var button_10 = $.first_child(fragment_6);
					var button_11 = $.sibling(button_10, 2);

					$.template_effect(() => button_11.disabled = $.get(deleteSelections).size === 0 || $.get(deleteDisabled));
					$.delegated('click', button_10, () => $.set(showDelete, false));
					$.delegated('click', button_11, () => $.set(deleteStep, "confirm"));
					$.append($$anchor, fragment_6);
				};

				$.if(node_9, ($$render) => {
					if ($.get(deleteStep) === "confirm") $$render(consequent_13); else $$render(alternate_3, -1);
				});
			}

			$.reset(div_15);
			$.reset(div_7);
			$.template_effect(() => $.set_text(text_5, $.get(deleteRouteLabel) || "(default)"));
			$.delegated('click', button_6, () => $.set(showDelete, false));
			$.append($$anchor, div_7);
		};

		var alternate_9 = ($$anchor) => {
			var div_16 = root_41();
			var div_17 = $.child(div_16);
			var button_12 = $.sibling($.child(div_17), 2);

			$.reset(div_17);

			var div_18 = $.sibling(div_17, 2);
			var button_13 = $.child(div_18);
			let classes;
			var button_14 = $.sibling(button_13, 2);
			var button_15 = $.sibling(button_14, 2);
			var button_16 = $.sibling(button_15, 2);
			var button_17 = $.sibling(button_16, 2);
			var button_18 = $.sibling(button_17, 2);
			let classes_1;

			$.reset(div_18);

			var div_19 = $.sibling(div_18, 2);
			var node_10 = $.child(div_19);

			{
				var consequent_15 = ($$anchor) => {
					var div_20 = root_11();
					var text_9 = $.only_child(div_20, true);

					$.template_effect(() => $.set_text(text_9, $.get(errorMessage)));
					$.append($$anchor, div_20);
				};

				$.if(node_10, ($$render) => {
					if ($.get(errorMessage)) $$render(consequent_15);
				});
			}

			var node_11 = $.sibling(node_10, 2);

			{
				var consequent_16 = ($$anchor) => {
					var div_21 = root_18();
					var p_4 = $.sibling($.child(div_21), 2);
					var text_10 = $.only_child(p_4, true);
					var div_22 = $.sibling(p_4, 2);
					var button_19 = $.child(div_22);
					var button_20 = $.sibling(button_19, 2);

					$.reset(div_22);
					$.reset(div_21);
					$.template_effect(() => $.set_text(text_10, $.get(pendingCleanup).description));
					$.delegated('click', button_19, cancelCleanup);
					$.delegated('click', button_20, applyCleanup);
					$.append($$anchor, div_21);
				};

				$.if(node_11, ($$render) => {
					if ($.get(pendingCleanup)) $$render(consequent_16);
				});
			}

			var node_12 = $.sibling(node_11, 2);

			{
				var consequent_17 = ($$anchor) => {
					var div_23 = root_19();
					var text_11 = $.only_child(div_23, true);

					$.template_effect(() => $.set_text(text_11, $.get(notice)));
					$.append($$anchor, div_23);
				};

				$.if(node_12, ($$render) => {
					if ($.get(notice)) $$render(consequent_17);
				});
			}

			var node_13 = $.sibling(node_12, 2);

			{
				var consequent_22 = ($$anchor) => {
					var div_24 = root_27();
					var div_25 = $.child(div_24);
					var div_26 = $.child(div_25);
					var button_21 = $.sibling($.child(div_26), 2);

					$.reset(div_26);

					var div_27 = $.sibling(div_26, 2);
					var div_28 = $.child(div_27);
					var div_29 = $.child(div_28);
					var span_4 = $.sibling($.child(div_29), 2);
					var text_12 = $.only_child(span_4, true);

					$.reset(div_29);

					var node_14 = $.sibling(div_29, 2);

					{
						var consequent_18 = ($$anchor) => {
							var button_22 = root_20();

							$.template_effect(() => button_22.disabled = $.get(isSaving) || $.get(isLoadingExample));
							$.delegated('click', button_22, openOnTheRunForm);
							$.append($$anchor, button_22);
						};

						var alternate_4 = ($$anchor) => {
							var button_23 = root_21();

							$.template_effect(() => button_23.disabled = $.get(isSaving) || $.get(isLoadingExample));
							$.delegated('click', button_23, restoreOnTheRun);
							$.append($$anchor, button_23);
						};

						$.if(node_14, ($$render) => {
							if ($.get(hasOnTheRunPage)) $$render(consequent_18); else $$render(alternate_4, -1);
						});
					}

					$.reset(div_28);

					var node_15 = $.sibling(div_28, 2);

					{
						var consequent_21 = ($$anchor) => {
							const draft = $.derived(() => $.get(onTheRunDraft));
							var div_30 = root_26();
							var div_31 = $.child(div_30);

							$.each(div_31, 21, () => ON_THE_RUN_FIELDS, (field) => field.key, ($$anchor, field) => {
								var label_3 = root_25();
								var span_5 = $.child(label_3);
								var text_13 = $.only_child(span_5, true);
								var node_16 = $.sibling(span_5, 2);

								{
									var consequent_19 = ($$anchor) => {
										var input_2 = root_22();

										$.remove_input_defaults(input_2);

										$.template_effect(() => {
											$.set_checked(input_2, $.get(draft)[$.get(field).key] === "true");
											$.set_attribute(input_2, 'aria-label', $.get(field).label);
										});

										$.delegated('change', input_2, (event) => $.get(draft)[$.get(field).key] = event.currentTarget.checked ? "true" : "false");
										$.append($$anchor, input_2);
									};

									var alternate_5 = ($$anchor) => {
										var input_3 = root_23();

										$.remove_input_defaults(input_3);

										$.template_effect(() => {
											$.set_attribute(input_3, 'type', $.get(field).kind === "number" ? "number" : "text");
											$.set_attribute(input_3, 'aria-label', $.get(field).label);
										});

										$.bind_value(input_3, () => $.get(draft)[$.get(field).key], ($$value) => $.get(draft)[$.get(field).key] = $$value);
										$.append($$anchor, input_3);
									};

									$.if(node_16, ($$render) => {
										if ($.get(field).kind === "boolean") $$render(consequent_19); else $$render(alternate_5, -1);
									});
								}

								var node_17 = $.sibling(node_16, 2);

								{
									var consequent_20 = ($$anchor) => {
										var small = root_24();
										var text_14 = $.only_child(small, true);

										$.template_effect(() => $.set_text(text_14, $.get(field).hint));
										$.append($$anchor, small);
									};

									$.if(node_17, ($$render) => {
										if ($.get(field).hint) $$render(consequent_20);
									});
								}

								$.reset(label_3);
								$.template_effect(() => $.set_text(text_13, $.get(field).label));
								$.append($$anchor, label_3);
							});

							$.reset(div_31);

							var div_32 = $.sibling(div_31, 2);
							var button_24 = $.child(div_32);
							var button_25 = $.sibling(button_24, 2);

							$.reset(div_32);
							$.reset(div_30);
							$.delegated('click', button_24, () => $.set(onTheRunDraft, null));
							$.delegated('click', button_25, applyOnTheRun);
							$.append($$anchor, div_30);
						};

						$.if(node_15, ($$render) => {
							if ($.get(onTheRunDraft) !== null) $$render(consequent_21);
						});
					}

					var node_18 = $.sibling(node_15, 2);

					ConfigPages(node_18, {
						get pages() {
							return $.get(configPages);
						},

						get defaults() {
							return $.get(globalDisplay);
						},
						onReorder: reorderPage,
						onRemovePage: deletePage,
						onRemoveStop: deleteStop,
						onApplyPage: applyPageEdit,
						onApplyStop: applyStopEdit,
						onApplyPageDisplay: applyPageDisplay,
						onApplyDefaults: applyDefaults,
						onAddPage: addPage,
						onAddStop: addStop,
						onAddStops: openWizard,
						onConvert: startCleanup
					});

					$.reset(div_27);

					var div_33 = $.sibling(div_27, 2);
					var div_34 = $.child(div_33);
					var button_26 = $.only_child(div_34);

					$.reset(div_33);
					$.reset(div_25);
					$.reset(div_24);
					$.template_effect(() => $.set_text(text_12, $.get(hasOnTheRunPage) ? "in this config" : "missing"));
					$.delegated('click', button_21, closeConfigurator);
					$.delegated('click', button_26, closeConfigurator);
					$.append($$anchor, div_24);
				};

				var alternate_7 = ($$anchor) => {
					var div_35 = root_38();
					var div_36 = $.child(div_35);
					var button_27 = $.child(div_36);
					var node_19 = $.sibling($.child(button_27), 2);

					{
						var consequent_23 = ($$anchor) => {
							var span_6 = root_28();

							$.append($$anchor, span_6);
						};

						$.if(node_19, ($$render) => {
							if ($.get(copySuccess)) $$render(consequent_23);
						});
					}

					$.reset(button_27);

					var button_28 = $.sibling(button_27, 2);
					var node_20 = $.sibling($.child(button_28), 2);

					{
						var consequent_24 = ($$anchor) => {
							var span_7 = root_28();

							$.append($$anchor, span_7);
						};

						var consequent_25 = ($$anchor) => {
							var span_8 = root_29();

							$.append($$anchor, span_8);
						};

						$.if(node_20, ($$render) => {
							if ($.get(pasteSuccess)) $$render(consequent_24); else if ($.get(pasteError)) $$render(consequent_25, 1);
						});
					}

					$.reset(button_28);

					var button_29 = $.sibling(button_28, 2);
					var button_30 = $.sibling(button_29, 2);

					$.reset(div_36);

					var div_37 = $.sibling(div_36, 2);
					var pre = $.child(div_37);
					var code = $.child(pre);

					$.html(code, () => $.get(highlightedToml), true);
					$.reset(code);
					$.reset(pre);
					$.bind_this(pre, ($$value) => $.set(highlightLayer, $$value), () => $.get(highlightLayer));

					var textarea = $.sibling(pre, 2);

					$.remove_textarea_child(textarea);

					let classes_2;

					$.reset(div_37);

					var node_21 = $.sibling(div_37, 2);

					{
						var consequent_26 = ($$anchor) => {
							var div_38 = root_30();
							var div_39 = $.child(div_38);
							var button_31 = $.child(div_39);
							var textarea_1 = $.sibling(button_31, 2);

							$.remove_textarea_child(textarea_1);
							$.reset(div_39);
							$.reset(div_38);

							$.delegated('keydown', div_38, (e) => {
								if (e.key === "Escape") $.set(showFullscreenEditor, false);
							});

							$.delegated('click', button_31, () => $.set(showFullscreenEditor, false));
							$.bind_value(textarea_1, () => $.get(configText), ($$value) => $.set(configText, $$value));
							$.append($$anchor, div_38);
						};

						$.if(node_21, ($$render) => {
							if ($.get(showFullscreenEditor)) $$render(consequent_26);
						});
					}

					var node_22 = $.sibling(node_21, 2);

					{
						var consequent_34 = ($$anchor) => {
							var div_40 = root_37();
							var div_41 = $.child(div_40);
							var div_42 = $.child(div_41);
							var div_43 = $.child(div_42);
							var input_4 = $.child(div_43);

							$.remove_input_defaults(input_4);
							$.bind_this(input_4, ($$value) => $.set(tweakFilterInputEl, $$value), () => $.get(tweakFilterInputEl));

							var node_23 = $.sibling(input_4, 2);

							{
								var consequent_27 = ($$anchor) => {
									var button_32 = root_31();

									$.delegated('mousedown', button_32, (e) => e.preventDefault());
									$.delegated('click', button_32, clearTweakFilter);
									$.append($$anchor, button_32);
								};

								var d = $.derived(() => $.get(tweakFilterQuery).trim());

								$.if(node_23, ($$render) => {
									if ($.get(d)) $$render(consequent_27);
								});
							}

							$.reset(div_43);

							var button_33 = $.sibling(div_43, 2);

							$.reset(div_42);

							var div_44 = $.sibling(div_42, 2);
							var node_24 = $.child(div_44);

							{
								var consequent_28 = ($$anchor) => {
									var p_5 = root_32();

									$.append($$anchor, p_5);
								};

								var alternate_6 = ($$anchor) => {
									var fragment_7 = $.comment();
									var node_25 = $.first_child(fragment_7);

									$.each(node_25, 17, () => $.get(tweakSections), $.index, ($$anchor, section, sectionIdx) => {
										const hasVisible = $.derived(() => tweakSectionHasVisibleEntries($.get(section), $.get(tweakFilterParts), sectionIdx));
										var fragment_8 = $.comment();
										var node_26 = $.first_child(fragment_8);

										{
											var consequent_33 = ($$anchor) => {
												var section_1 = root_36();
												var h3 = $.child(section_1);
												var text_15 = $.child(h3);
												var node_27 = $.sibling(text_15);

												{
													var consequent_30 = ($$anchor) => {
														const stationNameEntry = $.derived(() => $.get(section).entries.find((e) => e.key === "station_name"));
														var fragment_9 = $.comment();
														var node_28 = $.first_child(fragment_9);

														{
															var consequent_29 = ($$anchor) => {
																var span_9 = root_33();
																var text_16 = $.only_child(span_9, true);

																$.template_effect(() => $.set_text(text_16, $.get(stationNameEntry).value));
																$.append($$anchor, span_9);
															};

															$.if(node_28, ($$render) => {
																if ($.get(stationNameEntry)?.value) $$render(consequent_29);
															});
														}

														$.append($$anchor, fragment_9);
													};

													$.if(node_27, ($$render) => {
														if ($.get(section).heading === "[[routes.stops]]" || $.get(section).heading === "[[stops]]") $$render(consequent_30);
													});
												}

												$.reset(h3);

												var ul_2 = $.sibling(h3, 2);

												$.each(ul_2, 21, () => $.get(section).entries, (entry) => `${sectionIdx}-${entry.lineIndex}`, ($$anchor, entry, $$index_5) => {
													var fragment_10 = $.comment();
													var node_29 = $.first_child(fragment_10);

													{
														var consequent_32 = ($$anchor) => {
															var li_2 = root_35();
															var label_4 = $.child(li_2);
															var text_17 = $.child(label_4);
															var node_30 = $.sibling(text_17);

															{
																var consequent_31 = ($$anchor) => {
																	var span_10 = root_34();
																	var text_18 = $.only_child(span_10);

																	$.template_effect(() => $.set_text(text_18, `[${$.get(section).heading ?? ''}]`));
																	$.append($$anchor, span_10);
																};

																var d_1 = $.derived(() => $.get(tweakDuplicateKeys).has($.get(entry).key));

																$.if(node_30, ($$render) => {
																	if ($.get(d_1)) $$render(consequent_31);
																});
															}

															$.reset(label_4);

															var input_5 = $.sibling(label_4, 2);

															$.remove_input_defaults(input_5);
															$.reset(li_2);

															$.template_effect(
																($0) => {
																	$.set_attribute(label_4, 'for', `tweak-input-${sectionIdx}-${$.get(entry).lineIndex ?? ''}`);
																	$.set_text(text_17, `${$.get(entry).key ?? ''} `);
																	$.set_attribute(input_5, 'id', `tweak-input-${sectionIdx}-${$.get(entry).lineIndex ?? ''}`);
																	$.set_attribute(input_5, 'aria-label', $0);
																},
																[
																	() => $.get(tweakDuplicateKeys).has($.get(entry).key)
																		? `${$.get(entry).key} in ${$.get(section).heading}`
																		: $.get(entry).key
																]
															);

															$.event('focus', input_5, (e) => {
																$.set(lastTweakValueFocusedEl, e.currentTarget, true);
															});

															$.bind_value(input_5, () => $.get(entry).value, ($$value) => ($.get(entry).value = $$value));
															$.append($$anchor, li_2);
														};

														var d_2 = $.derived(() => tweakShowEntry($.get(section), $.get(entry), $.get(tweakFilterParts), sectionIdx));

														$.if(node_29, ($$render) => {
															if ($.get(d_2)) $$render(consequent_32);
														});
													}

													$.append($$anchor, fragment_10);
												});

												$.reset(ul_2);
												$.reset(section_1);
												$.template_effect(() => $.set_text(text_15, `${$.get(section).heading ?? ''} `));
												$.append($$anchor, section_1);
											};

											$.if(node_26, ($$render) => {
												if ($.get(hasVisible)) $$render(consequent_33);
											});
										}

										$.append($$anchor, fragment_8);
									});

									$.append($$anchor, fragment_7);
								};

								$.if(node_24, ($$render) => {
									if ($.get(tweakSections).length === 0) $$render(consequent_28); else $$render(alternate_6, -1);
								});
							}

							$.reset(div_44);
							$.reset(div_41);
							$.reset(div_40);

							$.delegated('keydown', div_40, (e) => {
								if (e.key === "Escape") closeTweakAndApply(); else if (e.key === "Enter") {
									e.preventDefault();
									closeTweakAndApply();
								}
							});

							$.bind_value(input_4, () => $.get(tweakFilterQuery), ($$value) => $.set(tweakFilterQuery, $$value));
							$.delegated('click', button_33, closeTweakAndApply);
							$.append($$anchor, div_40);
						};

						$.if(node_22, ($$render) => {
							if ($.get(showTweakOverlay)) $$render(consequent_34);
						});
					}

					$.reset(div_35);

					$.template_effect(
						($0, $1) => {
							$.set_attribute(button_27, 'title', $.get(copySuccess) ? "Copied!" : "Copy configuration to clipboard");
							button_27.disabled = $0;
							$.set_attribute(button_28, 'title', $.get(pasteSuccess) ? "Pasted!" : "Paste configuration from clipboard");
							button_28.disabled = $.get(isSaving) || $.get(isLoadingExample);
							button_29.disabled = $1;
							classes_2 = $.set_class(textarea, 1, 'config-textarea svelte-ha7zfr', null, classes_2, { error: !!$.get(errorMessage) });
							textarea.readOnly = $.get(showFullscreenEditor);
						},
						[
							() => !$.get(configText).trim() || $.get(isSaving) || $.get(isLoadingExample),
							() => !$.get(configText).trim() || $.get(isSaving) || $.get(isLoadingExample)
						]
					);

					$.delegated('click', button_27, handleCopy);
					$.delegated('click', button_28, handlePaste);
					$.delegated('click', button_29, openTweak);
					$.delegated('click', button_30, () => $.set(showFullscreenEditor, true));
					$.event('scroll', textarea, syncEditorScroll);
					$.bind_value(textarea, () => $.get(configText), ($$value) => $.set(configText, $$value));
					$.append($$anchor, div_35);
				};

				$.if(node_13, ($$render) => {
					if ($.get(view) === "pages") $$render(consequent_22); else $$render(alternate_7, -1);
				});
			}

			$.reset(div_19);

			var div_45 = $.sibling(div_19, 2);
			var div_46 = $.sibling($.child(div_45), 2);
			var node_31 = $.child(div_46);

			{
				var consequent_35 = ($$anchor) => {
					var fragment_11 = root_39();
					var button_34 = $.sibling($.first_child(fragment_11), 2);
					var button_35 = $.sibling(button_34, 2);

					$.delegated('click', button_34, () => $.set(confirmCancel, false));

					$.delegated('click', button_35, function (...$$args) {
						$$props.onCancel?.apply(this, $$args);
					});

					$.append($$anchor, fragment_11);
				};

				var alternate_8 = ($$anchor) => {
					var fragment_12 = root_40();
					var button_36 = $.first_child(fragment_12);
					var text_19 = $.only_child(button_36, true);
					var button_37 = $.sibling(button_36, 2);
					var button_38 = $.sibling(button_37, 2);
					var text_20 = $.only_child(button_38, true);

					$.template_effect(
						($0) => {
							button_36.disabled = $.get(isSaving) || $.get(isLoadingExample);
							$.set_text(text_19, $.get(isLoadingExample) ? "Loading..." : "Example");
							button_37.disabled = $.get(isSaving) || $.get(isLoadingExample);
							button_38.disabled = $0;
							$.set_text(text_20, $.get(isSaving) ? "Saving..." : "Save");
						},
						[
							() => !$.get(configText).trim() || $.get(isSaving) || $.get(isLoadingExample)
						]
					);

					$.delegated('click', button_36, () => loadExampleConfig());
					$.delegated('click', button_37, requestCancel);
					$.delegated('click', button_38, handleSave);
					$.append($$anchor, fragment_12);
				};

				$.if(node_31, ($$render) => {
					if ($.get(confirmCancel)) $$render(consequent_35); else $$render(alternate_8, -1);
				});
			}

			$.reset(div_46);
			$.reset(div_45);
			$.reset(div_16);

			$.template_effect(
				($0) => {
					classes = $.set_class(button_13, 1, 'method-button svelte-ha7zfr', null, classes, { 'method-button-active': $.get(view) === "toml" });
					$.set_attribute(button_13, 'aria-selected', $.get(view) === "toml");
					button_17.disabled = $0;
					classes_1 = $.set_class(button_18, 1, 'method-button svelte-ha7zfr', null, classes_1, { 'method-button-active': $.get(view) === "pages" });
					$.set_attribute(button_18, 'aria-selected', $.get(view) === "pages");
				},
				[
					() => !$.get(configText).trim() || $.get(isSaving) || $.get(isLoadingExample)
				]
			);

			$.delegated('click', button_12, requestCancel);
			$.delegated('click', button_13, () => $.set(view, "toml"));
			$.delegated('click', button_14, openWizard);
			$.delegated('click', button_15, startDeleteFlow);
			$.delegated('click', button_16, startDeleteRoutesFlow);
			$.delegated('click', button_17, startCleanup);
			$.delegated('click', button_18, () => $.set(view, "pages"));
			$.append($$anchor, div_16);
		};

		$.if(node, ($$render) => {
			if ($.get(showWizard)) $$render(consequent); else if ($.get(showDeleteRoutes)) $$render(consequent_7, 1); else if ($.get(showDelete)) $$render(consequent_14, 2); else $$render(alternate_9, -1);
		});
	}

	$.reset(div);

	$.delegated('click', div, (event) => {
		if (event.target === event.currentTarget) {
			$$props.onCancel();
		}
	});

	$.delegated('keydown', div, handleKeydown);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click', 'keydown', 'change', 'mousedown']);